/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		1:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + "" + chunkId + "-" + ({"0":"headroom"}[chunkId]||chunkId) + "-" + {"0":"dea7b1afaef7fcfef0c7","4":"2b678c5924e03c61d06a","5":"5263ddfb2f10c895ebe8"}[chunkId] + ".chunk.js";
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets/js/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(171);


/***/ }),
/* 1 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(29)('wks');
	var uid = __webpack_require__(26);
	var Symbol = __webpack_require__(1).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 3 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.9' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(7);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(18)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(8);
	var createDesc = __webpack_require__(23);
	module.exports = __webpack_require__(5) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 7 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(4);
	var IE8_DOM_DEFINE = __webpack_require__(41);
	var toPrimitive = __webpack_require__(39);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(5) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(1);
	var core = __webpack_require__(3);
	var ctx = __webpack_require__(15);
	var hide = __webpack_require__(6);
	var has = __webpack_require__(10);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 10 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 11 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 12 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(55);
	var defined = __webpack_require__(20);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 14 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(14);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 16 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 17 */
/***/ (function(module, exports) {

	module.exports = jQuery;

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(8).f;
	var has = __webpack_require__(10);
	var TAG = __webpack_require__(2)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(7);
	var document = __webpack_require__(1).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(14);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 23 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(29)('keys');
	var uid = __webpack_require__(26);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 25 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 26 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 27 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(43);
	var enumBugKeys = __webpack_require__(27);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(3);
	var global = __webpack_require__(1);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(16) ? 'pure' : 'global',
	  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(12);
	var TAG = __webpack_require__(2)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(1).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(16);
	var $export = __webpack_require__(9);
	var redefine = __webpack_require__(44);
	var hide = __webpack_require__(6);
	var Iterators = __webpack_require__(11);
	var $iterCreate = __webpack_require__(58);
	var setToStringTag = __webpack_require__(19);
	var getPrototypeOf = __webpack_require__(63);
	var ITERATOR = __webpack_require__(2)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 33 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(4);
	var isObject = __webpack_require__(7);
	var newPromiseCapability = __webpack_require__(22);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(4);
	var aFunction = __webpack_require__(14);
	var SPECIES = __webpack_require__(2)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(15);
	var invoke = __webpack_require__(54);
	var html = __webpack_require__(31);
	var cel = __webpack_require__(21);
	var global = __webpack_require__(1);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(12)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(25);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(20);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(7);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(49), __esModule: true };

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(5) && !__webpack_require__(18)(function () {
	  return Object.defineProperty(__webpack_require__(21)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(4);
	var dPs = __webpack_require__(62);
	var enumBugKeys = __webpack_require__(27);
	var IE_PROTO = __webpack_require__(24)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(21)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(31).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(10);
	var toIObject = __webpack_require__(13);
	var arrayIndexOf = __webpack_require__(52)(false);
	var IE_PROTO = __webpack_require__(24)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(6);


/***/ }),
/* 45 */
/***/ (function(module, exports) {



/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(67)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(32)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(73);
	var global = __webpack_require__(1);
	var hide = __webpack_require__(6);
	var Iterators = __webpack_require__(11);
	var TO_STRING_TAG = __webpack_require__(2)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(189);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(188);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(45);
	__webpack_require__(46);
	__webpack_require__(47);
	__webpack_require__(74);
	__webpack_require__(75);
	__webpack_require__(76);
	module.exports = __webpack_require__(3).Promise;


/***/ }),
/* 50 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 51 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(13);
	var toLength = __webpack_require__(37);
	var toAbsoluteIndex = __webpack_require__(68);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(15);
	var call = __webpack_require__(57);
	var isArrayIter = __webpack_require__(56);
	var anObject = __webpack_require__(4);
	var toLength = __webpack_require__(37);
	var getIterFn = __webpack_require__(72);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 54 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(12);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(11);
	var ITERATOR = __webpack_require__(2)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(4);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(42);
	var descriptor = __webpack_require__(23);
	var setToStringTag = __webpack_require__(19);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(6)(IteratorPrototype, __webpack_require__(2)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(2)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 60 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(1);
	var macrotask = __webpack_require__(36).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(12)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(8);
	var anObject = __webpack_require__(4);
	var getKeys = __webpack_require__(28);
	
	module.exports = __webpack_require__(5) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(10);
	var toObject = __webpack_require__(38);
	var IE_PROTO = __webpack_require__(24)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 64 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	var hide = __webpack_require__(6);
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    if (safe && target[key]) target[key] = src[key];
	    else hide(target, key, src[key]);
	  } return target;
	};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(1);
	var core = __webpack_require__(3);
	var dP = __webpack_require__(8);
	var DESCRIPTORS = __webpack_require__(5);
	var SPECIES = __webpack_require__(2)('species');
	
	module.exports = function (KEY) {
	  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(25);
	var defined = __webpack_require__(20);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(25);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(1);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(1);
	var core = __webpack_require__(3);
	var LIBRARY = __webpack_require__(16);
	var wksExt = __webpack_require__(71);
	var defineProperty = __webpack_require__(8).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(2);


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(30);
	var ITERATOR = __webpack_require__(2)('iterator');
	var Iterators = __webpack_require__(11);
	module.exports = __webpack_require__(3).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(50);
	var step = __webpack_require__(60);
	var Iterators = __webpack_require__(11);
	var toIObject = __webpack_require__(13);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(32)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(16);
	var global = __webpack_require__(1);
	var ctx = __webpack_require__(15);
	var classof = __webpack_require__(30);
	var $export = __webpack_require__(9);
	var isObject = __webpack_require__(7);
	var aFunction = __webpack_require__(14);
	var anInstance = __webpack_require__(51);
	var forOf = __webpack_require__(53);
	var speciesConstructor = __webpack_require__(35);
	var task = __webpack_require__(36).set;
	var microtask = __webpack_require__(61)();
	var newPromiseCapabilityModule = __webpack_require__(22);
	var perform = __webpack_require__(33);
	var userAgent = __webpack_require__(69);
	var promiseResolve = __webpack_require__(34);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(2)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(65)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(19)($Promise, PROMISE);
	__webpack_require__(66)(PROMISE);
	Wrapper = __webpack_require__(3)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(59)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(9);
	var core = __webpack_require__(3);
	var global = __webpack_require__(1);
	var speciesConstructor = __webpack_require__(35);
	var promiseResolve = __webpack_require__(34);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(9);
	var newPromiseCapability = __webpack_require__(22);
	var perform = __webpack_require__(33);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 77 */,
/* 78 */,
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * JavaScript Cookie v2.1.4
	 * https://github.com/js-cookie/js-cookie
	 *
	 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
	 * Released under the MIT license
	 */
	;(function (factory) {
		var registeredInModuleLoader = false;
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			registeredInModuleLoader = true;
		}
		if (true) {
			module.exports = factory();
			registeredInModuleLoader = true;
		}
		if (!registeredInModuleLoader) {
			var OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = OldCookies;
				return api;
			};
		}
	}(function () {
		function extend () {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[ i ];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}
	
		function init (converter) {
			function api (key, value, attributes) {
				var result;
				if (typeof document === 'undefined') {
					return;
				}
	
				// Write
	
				if (arguments.length > 1) {
					attributes = extend({
						path: '/'
					}, api.defaults, attributes);
	
					if (typeof attributes.expires === 'number') {
						var expires = new Date();
						expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
						attributes.expires = expires;
					}
	
					// We're using "expires" because "max-age" is not supported by IE
					attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
	
					try {
						result = JSON.stringify(value);
						if (/^[\{\[]/.test(result)) {
							value = result;
						}
					} catch (e) {}
	
					if (!converter.write) {
						value = encodeURIComponent(String(value))
							.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
					} else {
						value = converter.write(value, key);
					}
	
					key = encodeURIComponent(String(key));
					key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
					key = key.replace(/[\(\)]/g, escape);
	
					var stringifiedAttributes = '';
	
					for (var attributeName in attributes) {
						if (!attributes[attributeName]) {
							continue;
						}
						stringifiedAttributes += '; ' + attributeName;
						if (attributes[attributeName] === true) {
							continue;
						}
						stringifiedAttributes += '=' + attributes[attributeName];
					}
					return (document.cookie = key + '=' + value + stringifiedAttributes);
				}
	
				// Read
	
				if (!key) {
					result = {};
				}
	
				// To prevent the for loop in the first place assign an empty array
				// in case there are no cookies at all. Also prevents odd result when
				// calling "get()"
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var rdecode = /(%[0-9A-Z]{2})+/g;
				var i = 0;
	
				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var cookie = parts.slice(1).join('=');
	
					if (cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}
	
					try {
						var name = parts[0].replace(rdecode, decodeURIComponent);
						cookie = converter.read ?
							converter.read(cookie, name) : converter(cookie, name) ||
							cookie.replace(rdecode, decodeURIComponent);
	
						if (this.json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}
	
						if (key === name) {
							result = cookie;
							break;
						}
	
						if (!key) {
							result[name] = cookie;
						}
					} catch (e) {}
				}
	
				return result;
			}
	
			api.set = api;
			api.get = function (key) {
				return api.call(api, key);
			};
			api.getJSON = function () {
				return api.apply({
					json: true
				}, [].slice.call(arguments));
			};
			api.defaults = {};
	
			api.remove = function (key, attributes) {
				api(key, '', extend(attributes, {
					expires: -1
				}));
			};
	
			api.withConverter = init;
	
			return api;
		}
	
		return init(function () {});
	}));


/***/ }),
/* 80 */,
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(43);
	var hiddenKeys = __webpack_require__(27).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 82 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 83 */
/***/ (function(module, exports) {

	/*!
	 * headroom.js v0.9.4 - Give your page some headroom. Hide your header until you need it
	 * Copyright (c) 2017 Nick Williams - http://wicky.nillia.ms/headroom.js
	 * License: MIT
	 */
	
	(function($) {
	
	  if(!$) {
	    return;
	  }
	
	  ////////////
	  // Plugin //
	  ////////////
	
	  $.fn.headroom = function(option) {
	    return this.each(function() {
	      var $this   = $(this),
	        data      = $this.data('headroom'),
	        options   = typeof option === 'object' && option;
	
	      options = $.extend(true, {}, Headroom.options, options);
	
	      if (!data) {
	        data = new Headroom(this, options);
	        data.init();
	        $this.data('headroom', data);
	      }
	      if (typeof option === 'string') {
	        data[option]();
	
	        if(option === 'destroy'){
	          $this.removeData('headroom');
	        }
	      }
	    });
	  };
	
	  //////////////
	  // Data API //
	  //////////////
	
	  $('[data-headroom]').each(function() {
	    var $this = $(this);
	    $this.headroom($this.data());
	  });
	
	}(window.Zepto || window.jQuery));

/***/ }),
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    // return cached browser if available
	    if (browser !== undefined) {
	        return browser;
	    }
	
	    var n,
	        v,
	        app = "",
	        ua = navigator.userAgent || navigator.vendor || window.opera,
	        donotnotify = false;
	    var names = { i: 'Internet Explorer', f: 'Firefox', o: 'Opera', s: 'Apple Safari', n: 'Netscape Navigator', c: "Chrome", a: "Android", x: "Other", fb: "Facebook" };
	    // modified by SPiNNWERK:
	    //   removed: android|phone|iPad|iPhone|iPod
	    if (/bot|googlebot|facebook|slurp|wii|silk|blackberry|maxthon|maxton|mediapartners|dolfin|dolphin|adsbot|silk|bingbot|google web preview|like firefox|chromeframe|seamonkey|opera mini|min|meego|netfront|moblin|maemo|arora|camino|flot|k-meleon|fennec|kazehakase|galeon|epiphany|konqueror|rekonq|symbian|webos|coolnovo|blackberry|bb10|RIM|PlayBook|PaleMoon|QupZilla/i.test(ua)) n = "x";else if (/Trident.*rv:(\d+\.\d+)/i.test(ua)) n = "i";else if (/Trident.(\d+\.\d+)/i.test(ua)) n = "io";else if (/MSIE.(\d+\.\d+)/i.test(ua)) n = "i";else if (/Edge.(\d+\.\d+)/i.test(ua)) n = "i";else if (/OPR.(\d+\.\d+)/i.test(ua)) n = "o";else if (/Chrome.(\d+\.\d+)/i.test(ua)) n = "c";else if (/Firefox.(\d+\.\d+)/i.test(ua)) n = "f";
	    // added by SPiNNWERK:
	    //   check for Android versions
	    else if (/Android.(\d+\.?\d+)/i.test(ua)) n = "a";else if (/Version.(\d+.\d+).{0,10}Safari/i.test(ua)) n = "s";else if (/Safari.(\d+)/i.test(ua)) n = "so";else if (/Opera.*Version.(\d+\.\d+)/i.test(ua)) n = "o";else if (/Opera.(\d+\.?\d+)/i.test(ua)) n = "o";else if (/Netscape.(\d+)/i.test(ua)) n = "n";else return { n: "x", v: 0, t: names[n] };
	
	    v = parseFloat(RegExp.$1);
	
	    // do not notify very old systems since their is no up-to-date browser available
	    if (/windows.nt.5.0|windows.nt.4.0|windows.98|os x 10.4|os x 10.5|os x 10.3|os x 10.2/.test(ua)) {
	        donotnotify = "oldOS";
	    }
	
	    // do not notify firefox ESR
	    if (n == "f" && (Math.round(v) == 24 || Math.round(v) == 31)) {
	        donotnotify = "ESR";
	    }
	    // do not notify opera 12 on linux since it is the latest version
	    if (/linux|x11|unix|bsd/.test(ua) && n == "o" && v > 12) {
	        donotnotify = "Opera12Linux";
	    }
	
	    if (n == "x") {
	        return { n: "x", v: v || 0, t: names[n], donotnotify: donotnotify };
	    }
	
	    // added by SPiNNWERK:
	    //   expect we have an Safari iOS device (iPhone, iPod, iPad) parse the right version number
	    if (n == "so") {
	        if (/(iPad|iPhone|iPod|iPod touch);.*CPU.*OS (\d+\_?\d+)/i.test(ua)) {
	            v = parseFloat(RegExp.$2.replace('_', '.'));
	            n = "s";
	        }
	    }
	
	    if (n == "i" && v == 7 && window.XDomainRequest) {
	        v = 8;
	    }
	
	    if (n == "io") {
	        n = "i";
	        if (v > 6) v = 11;else if (v > 5) v = 10;else if (v > 4) v = 9;else if (v > 3.1) v = 8;else if (v > 3) v = 7;else v = 9;
	    }
	
	    // added by SPiNNWERK:
	    //   check if the user is in an "in app browser"
	    //
	    // check for facebook in app browser
	    // http://stackoverflow.com/questions/31569518/how-to-detect-facebook-in-app-browser#32348687
	    if (ua.indexOf("FBAN") > -1 || ua.indexOf("FBAV") > -1) app = "fb";
	
	    browser = { n: n, v: v, app: app, t: names[n] + " " + v, donotnotify: donotnotify };
	
	    return browser;
	};
	
	/**
	 * store the browser to only execute once
	 */
	var browser;
	
	/**
	 * get the browser and it's version
	 *   Taken and modified from: http://www.browser-update.org/
	 *   Look for "by SPiNNWERK" comments for more info
	 */

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (configs) {
	    // return cached browser if available
	    if (oldBrowser !== undefined) {
	        return oldBrowser;
	    }
	
	    var vs = {
	        i: configs.ie,
	        f: configs.firefox,
	        c: configs.chrome,
	        o: configs.opera,
	        s: configs.safari,
	        a: configs.android
	    },
	        browser = (0, _getBrowser2.default)(),
	        doc = document.documentElement,
	        mobileDetect = new _mobileDetect2.default(navigator.userAgent);
	
	    oldBrowser = browser.v < vs[browser.n];
	
	    // add the oldie class to the html element when we have an old browser
	    if (oldBrowser) {
	        doc.className += ' oldie';
	    }
	
	    // store the value in window.oldBrowser
	    window.oldie = oldBrowser;
	
	    // ===================================================================
	    //                     browser detection helper
	    // ===================================================================
	
	    // add the user agent as data attribute
	    doc.setAttribute('data-useragent', navigator.userAgent);
	
	    // if the user in in an application (like facebook "in app browser")
	    doc.setAttribute('data-app', browser.app);
	
	    // add the browser abbreviation as data attribute
	    doc.setAttribute('data-browser', browser.n);
	
	    if (browser.n === 's') {
	        // add the safari data attribute when its Safari
	        doc.setAttribute('data-safari', browser.v);
	    } else if (browser.n === 'i') {
	        // add IE data attribute when we have one
	        doc.setAttribute('data-ie', browser.v);
	    } else if (browser.n === 'c') {
	        // add Chrome data attribute when we have one
	        doc.setAttribute('data-chrome', browser.v);
	    } else if (browser.n === 'f') {
	        // add FF data attribute when we have one
	        doc.setAttribute('data-ff', browser.v);
	    } else if (browser.n === 'o') {
	        // add Opera data attribute when we have one
	        doc.setAttribute('data-opera', browser.v);
	    } else if (browser.n === 'a') {
	        // add Android data attribute when we have one
	        doc.setAttribute('data-android', browser.v);
	    }
	
	    doc.setAttribute('data-mobile', !!mobileDetect.mobile());
	    doc.setAttribute('data-tablet', !!mobileDetect.tablet());
	
	    return oldBrowser;
	};
	
	var _getBrowser = __webpack_require__(157);
	
	var _getBrowser2 = _interopRequireDefault(_getBrowser);
	
	var _mobileDetect = __webpack_require__(222);
	
	var _mobileDetect2 = _interopRequireDefault(_mobileDetect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * store the oldie check value
	 */
	/* eslint-disable no-implicit-coercion */
	
	var oldBrowser;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _promise = __webpack_require__(40);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$top = _ref.top,
	        top = _ref$top === undefined ? 0 : _ref$top,
	        _ref$duration = _ref.duration,
	        duration = _ref$duration === undefined ? 1000 : _ref$duration,
	        easing = _ref.easing,
	        callback = _ref.callback;
	
	    if (callback) {
	        (0, _jquery2.default)('html,body').animate({ scrollTop: top }, duration, easing, callback);
	    } else {
	        return new _promise2.default(function (resolve) {
	            (0, _jquery2.default)('html,body').animate({ scrollTop: top }, duration, easing, function () {
	                resolve();
	            });
	        });
	    }
	};
	
	var _jquery = __webpack_require__(17);
	
	var _jquery2 = _interopRequireDefault(_jquery);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$selector = _ref.selector,
	        selector = _ref$selector === undefined ? '.scroll-up' : _ref$selector,
	        _ref$duration = _ref.duration,
	        duration = _ref$duration === undefined ? 1000 : _ref$duration,
	        _ref$offsetTop = _ref.offsetTop,
	        offsetTop = _ref$offsetTop === undefined ? 300 : _ref$offsetTop,
	        _ref$scrollOffset = _ref.scrollOffset,
	        scrollOffset = _ref$scrollOffset === undefined ? 0 : _ref$scrollOffset;
	
	    var $scrollUp = (0, _jquery2.default)(selector);
	
	    // scroll top on click
	    $scrollUp.on('click', function (event) {
	        event.preventDefault();
	
	        (0, _scrollTo2.default)({
	            top: scrollOffset,
	            duration: duration
	        });
	    });
	
	    // only show the button after the offset
	    (0, _jquery2.default)(window).scroll(function () {
	        if (window.pageYOffset >= offsetTop) {
	            $scrollUp.fadeIn('fast');
	        } else {
	            $scrollUp.fadeOut('fast');
	        }
	    });
	};
	
	var _jquery = __webpack_require__(17);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _scrollTo = __webpack_require__(159);
	
	var _scrollTo2 = _interopRequireDefault(_scrollTo);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _keys = __webpack_require__(187);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(48);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	!function ($) {
	
	  "use strict";
	
	  var FOUNDATION_VERSION = '6.3.1';
	
	  // Global Foundation object
	  // This is attached to the window, or used as a module for AMD/Browserify
	  var Foundation = {
	    version: FOUNDATION_VERSION,
	
	    /**
	     * Stores initialized plugins.
	     */
	    _plugins: {},
	
	    /**
	     * Stores generated unique ids for plugin instances
	     */
	    _uuids: [],
	
	    /**
	     * Returns a boolean for RTL support
	     */
	    rtl: function rtl() {
	      return $('html').attr('dir') === 'rtl';
	    },
	    /**
	     * Defines a Foundation plugin, adding it to the `Foundation` namespace and the list of plugins to initialize when reflowing.
	     * @param {Object} plugin - The constructor of the plugin.
	     */
	    plugin: function plugin(_plugin, name) {
	      // Object key to use when adding to global Foundation object
	      // Examples: Foundation.Reveal, Foundation.OffCanvas
	      var className = name || functionName(_plugin);
	      // Object key to use when storing the plugin, also used to create the identifying data attribute for the plugin
	      // Examples: data-reveal, data-off-canvas
	      var attrName = hyphenate(className);
	
	      // Add to the Foundation object and the plugins list (for reflowing)
	      this._plugins[attrName] = this[className] = _plugin;
	    },
	    /**
	     * @function
	     * Populates the _uuids array with pointers to each individual plugin instance.
	     * Adds the `zfPlugin` data-attribute to programmatically created plugins to allow use of $(selector).foundation(method) calls.
	     * Also fires the initialization event for each plugin, consolidating repetitive code.
	     * @param {Object} plugin - an instance of a plugin, usually `this` in context.
	     * @param {String} name - the name of the plugin, passed as a camelCased string.
	     * @fires Plugin#init
	     */
	    registerPlugin: function registerPlugin(plugin, name) {
	      var pluginName = name ? hyphenate(name) : functionName(plugin.constructor).toLowerCase();
	      plugin.uuid = this.GetYoDigits(6, pluginName);
	
	      if (!plugin.$element.attr('data-' + pluginName)) {
	        plugin.$element.attr('data-' + pluginName, plugin.uuid);
	      }
	      if (!plugin.$element.data('zfPlugin')) {
	        plugin.$element.data('zfPlugin', plugin);
	      }
	      /**
	       * Fires when the plugin has initialized.
	       * @event Plugin#init
	       */
	      plugin.$element.trigger('init.zf.' + pluginName);
	
	      this._uuids.push(plugin.uuid);
	
	      return;
	    },
	    /**
	     * @function
	     * Removes the plugins uuid from the _uuids array.
	     * Removes the zfPlugin data attribute, as well as the data-plugin-name attribute.
	     * Also fires the destroyed event for the plugin, consolidating repetitive code.
	     * @param {Object} plugin - an instance of a plugin, usually `this` in context.
	     * @fires Plugin#destroyed
	     */
	    unregisterPlugin: function unregisterPlugin(plugin) {
	      var pluginName = hyphenate(functionName(plugin.$element.data('zfPlugin').constructor));
	
	      this._uuids.splice(this._uuids.indexOf(plugin.uuid), 1);
	      plugin.$element.removeAttr('data-' + pluginName).removeData('zfPlugin')
	      /**
	       * Fires when the plugin has been destroyed.
	       * @event Plugin#destroyed
	       */
	      .trigger('destroyed.zf.' + pluginName);
	      for (var prop in plugin) {
	        plugin[prop] = null; //clean up script to prep for garbage collection.
	      }
	      return;
	    },
	
	    /**
	     * @function
	     * Causes one or more active plugins to re-initialize, resetting event listeners, recalculating positions, etc.
	     * @param {String} plugins - optional string of an individual plugin key, attained by calling `$(element).data('pluginName')`, or string of a plugin class i.e. `'dropdown'`
	     * @default If no argument is passed, reflow all currently active plugins.
	     */
	    reInit: function reInit(plugins) {
	      var isJQ = plugins instanceof $;
	      try {
	        if (isJQ) {
	          plugins.each(function () {
	            $(this).data('zfPlugin')._init();
	          });
	        } else {
	          var type = typeof plugins === 'undefined' ? 'undefined' : (0, _typeof3.default)(plugins),
	              _this = this,
	              fns = {
	            'object': function object(plgs) {
	              plgs.forEach(function (p) {
	                p = hyphenate(p);
	                $('[data-' + p + ']').foundation('_init');
	              });
	            },
	            'string': function string() {
	              plugins = hyphenate(plugins);
	              $('[data-' + plugins + ']').foundation('_init');
	            },
	            'undefined': function undefined() {
	              this['object']((0, _keys2.default)(_this._plugins));
	            }
	          };
	          fns[type](plugins);
	        }
	      } catch (err) {
	        console.error(err);
	      } finally {
	        return plugins;
	      }
	    },
	
	    /**
	     * returns a random base-36 uid with namespacing
	     * @function
	     * @param {Number} length - number of random base-36 digits desired. Increase for more random strings.
	     * @param {String} namespace - name of plugin to be incorporated in uid, optional.
	     * @default {String} '' - if no plugin name is provided, nothing is appended to the uid.
	     * @returns {String} - unique id
	     */
	    GetYoDigits: function GetYoDigits(length, namespace) {
	      length = length || 6;
	      return Math.round(Math.pow(36, length + 1) - Math.random() * Math.pow(36, length)).toString(36).slice(1) + (namespace ? '-' + namespace : '');
	    },
	    /**
	     * Initialize plugins on any elements within `elem` (and `elem` itself) that aren't already initialized.
	     * @param {Object} elem - jQuery object containing the element to check inside. Also checks the element itself, unless it's the `document` object.
	     * @param {String|Array} plugins - A list of plugins to initialize. Leave this out to initialize everything.
	     */
	    reflow: function reflow(elem, plugins) {
	
	      // If plugins is undefined, just grab everything
	      if (typeof plugins === 'undefined') {
	        plugins = (0, _keys2.default)(this._plugins);
	      }
	      // If plugins is a string, convert it to an array with one item
	      else if (typeof plugins === 'string') {
	          plugins = [plugins];
	        }
	
	      var _this = this;
	
	      // Iterate through each plugin
	      $.each(plugins, function (i, name) {
	        // Get the current plugin
	        var plugin = _this._plugins[name];
	
	        // Localize the search to all elements inside elem, as well as elem itself, unless elem === document
	        var $elem = $(elem).find('[data-' + name + ']').addBack('[data-' + name + ']');
	
	        // For each plugin found, initialize it
	        $elem.each(function () {
	          var $el = $(this),
	              opts = {};
	          // Don't double-dip on plugins
	          if ($el.data('zfPlugin')) {
	            console.warn("Tried to initialize " + name + " on an element that already has a Foundation plugin.");
	            return;
	          }
	
	          if ($el.attr('data-options')) {
	            var thing = $el.attr('data-options').split(';').forEach(function (e, i) {
	              var opt = e.split(':').map(function (el) {
	                return el.trim();
	              });
	              if (opt[0]) opts[opt[0]] = parseValue(opt[1]);
	            });
	          }
	          try {
	            $el.data('zfPlugin', new plugin($(this), opts));
	          } catch (er) {
	            console.error(er);
	          } finally {
	            return;
	          }
	        });
	      });
	    },
	    getFnName: functionName,
	    transitionend: function transitionend($elem) {
	      var transitions = {
	        'transition': 'transitionend',
	        'WebkitTransition': 'webkitTransitionEnd',
	        'MozTransition': 'transitionend',
	        'OTransition': 'otransitionend'
	      };
	      var elem = document.createElement('div'),
	          end;
	
	      for (var t in transitions) {
	        if (typeof elem.style[t] !== 'undefined') {
	          end = transitions[t];
	        }
	      }
	      if (end) {
	        return end;
	      } else {
	        end = setTimeout(function () {
	          $elem.triggerHandler('transitionend', [$elem]);
	        }, 1);
	        return 'transitionend';
	      }
	    }
	  };
	
	  Foundation.util = {
	    /**
	     * Function for applying a debounce effect to a function call.
	     * @function
	     * @param {Function} func - Function to be called at end of timeout.
	     * @param {Number} delay - Time in ms to delay the call of `func`.
	     * @returns function
	     */
	    throttle: function throttle(func, delay) {
	      var timer = null;
	
	      return function () {
	        var context = this,
	            args = arguments;
	
	        if (timer === null) {
	          timer = setTimeout(function () {
	            func.apply(context, args);
	            timer = null;
	          }, delay);
	        }
	      };
	    }
	  };
	
	  // TODO: consider not making this a jQuery function
	  // TODO: need way to reflow vs. re-initialize
	  /**
	   * The Foundation jQuery method.
	   * @param {String|Array} method - An action to perform on the current jQuery object.
	   */
	  var foundation = function foundation(method) {
	    var type = typeof method === 'undefined' ? 'undefined' : (0, _typeof3.default)(method),
	        $meta = $('meta.foundation-mq'),
	        $noJS = $('.no-js');
	
	    if (!$meta.length) {
	      $('<meta class="foundation-mq">').appendTo(document.head);
	    }
	    if ($noJS.length) {
	      $noJS.removeClass('no-js');
	    }
	
	    if (type === 'undefined') {
	      //needs to initialize the Foundation object, or an individual plugin.
	      Foundation.MediaQuery._init();
	      Foundation.reflow(this);
	    } else if (type === 'string') {
	      //an individual method to invoke on a plugin or group of plugins
	      var args = Array.prototype.slice.call(arguments, 1); //collect all the arguments, if necessary
	      var plugClass = this.data('zfPlugin'); //determine the class of plugin
	
	      if (plugClass !== undefined && plugClass[method] !== undefined) {
	        //make sure both the class and method exist
	        if (this.length === 1) {
	          //if there's only one, call it directly.
	          plugClass[method].apply(plugClass, args);
	        } else {
	          this.each(function (i, el) {
	            //otherwise loop through the jQuery collection and invoke the method on each
	            plugClass[method].apply($(el).data('zfPlugin'), args);
	          });
	        }
	      } else {
	        //error for no class or no method
	        throw new ReferenceError("We're sorry, '" + method + "' is not an available method for " + (plugClass ? functionName(plugClass) : 'this element') + '.');
	      }
	    } else {
	      //error for invalid argument type
	      throw new TypeError('We\'re sorry, ' + type + ' is not a valid parameter. You must use a string representing the method you wish to invoke.');
	    }
	    return this;
	  };
	
	  window.Foundation = Foundation;
	  $.fn.foundation = foundation;
	
	  // Polyfill for requestAnimationFrame
	  (function () {
	    if (!Date.now || !window.Date.now) window.Date.now = Date.now = function () {
	      return new Date().getTime();
	    };
	
	    var vendors = ['webkit', 'moz'];
	    for (var i = 0; i < vendors.length && !window.requestAnimationFrame; ++i) {
	      var vp = vendors[i];
	      window.requestAnimationFrame = window[vp + 'RequestAnimationFrame'];
	      window.cancelAnimationFrame = window[vp + 'CancelAnimationFrame'] || window[vp + 'CancelRequestAnimationFrame'];
	    }
	    if (/iP(ad|hone|od).*OS 6/.test(window.navigator.userAgent) || !window.requestAnimationFrame || !window.cancelAnimationFrame) {
	      var lastTime = 0;
	      window.requestAnimationFrame = function (callback) {
	        var now = Date.now();
	        var nextTime = Math.max(lastTime + 16, now);
	        return setTimeout(function () {
	          callback(lastTime = nextTime);
	        }, nextTime - now);
	      };
	      window.cancelAnimationFrame = clearTimeout;
	    }
	    /**
	     * Polyfill for performance.now, required by rAF
	     */
	    if (!window.performance || !window.performance.now) {
	      window.performance = {
	        start: Date.now(),
	        now: function now() {
	          return Date.now() - this.start;
	        }
	      };
	    }
	  })();
	  if (!Function.prototype.bind) {
	    Function.prototype.bind = function (oThis) {
	      if (typeof this !== 'function') {
	        // closest thing possible to the ECMAScript 5
	        // internal IsCallable function
	        throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
	      }
	
	      var aArgs = Array.prototype.slice.call(arguments, 1),
	          fToBind = this,
	          fNOP = function fNOP() {},
	          fBound = function fBound() {
	        return fToBind.apply(this instanceof fNOP ? this : oThis, aArgs.concat(Array.prototype.slice.call(arguments)));
	      };
	
	      if (this.prototype) {
	        // native functions don't have a prototype
	        fNOP.prototype = this.prototype;
	      }
	      fBound.prototype = new fNOP();
	
	      return fBound;
	    };
	  }
	  // Polyfill to get the name of a function in IE9
	  function functionName(fn) {
	    if (Function.prototype.name === undefined) {
	      var funcNameRegex = /function\s([^(]{1,})\(/;
	      var results = funcNameRegex.exec(fn.toString());
	      return results && results.length > 1 ? results[1].trim() : "";
	    } else if (fn.prototype === undefined) {
	      return fn.constructor.name;
	    } else {
	      return fn.prototype.constructor.name;
	    }
	  }
	  function parseValue(str) {
	    if ('true' === str) return true;else if ('false' === str) return false;else if (!isNaN(str * 1)) return parseFloat(str);
	    return str;
	  }
	  // Convert PascalCase to kebab-case
	  // Thank you: http://stackoverflow.com/a/8955580
	  function hyphenate(str) {
	    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
	  }
	}(jQuery);

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck2 = __webpack_require__(191);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(192);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	!function ($) {
	
	  /**
	   * OffCanvas module.
	   * @module foundation.offcanvas
	   * @requires foundation.util.keyboard
	   * @requires foundation.util.mediaQuery
	   * @requires foundation.util.triggers
	   * @requires foundation.util.motion
	   */
	
	  var OffCanvas = function () {
	    /**
	     * Creates a new instance of an off-canvas wrapper.
	     * @class
	     * @fires OffCanvas#init
	     * @param {Object} element - jQuery object to initialize.
	     * @param {Object} options - Overrides to the default plugin settings.
	     */
	    function OffCanvas(element, options) {
	      (0, _classCallCheck3.default)(this, OffCanvas);
	
	      this.$element = element;
	      this.options = $.extend({}, OffCanvas.defaults, this.$element.data(), options);
	      this.$lastTrigger = $();
	      this.$triggers = $();
	
	      this._init();
	      this._events();
	
	      Foundation.registerPlugin(this, 'OffCanvas');
	      Foundation.Keyboard.register('OffCanvas', {
	        'ESCAPE': 'close'
	      });
	    }
	
	    /**
	     * Initializes the off-canvas wrapper by adding the exit overlay (if needed).
	     * @function
	     * @private
	     */
	
	
	    (0, _createClass3.default)(OffCanvas, [{
	      key: '_init',
	      value: function _init() {
	        var id = this.$element.attr('id');
	
	        this.$element.attr('aria-hidden', 'true');
	
	        this.$element.addClass('is-transition-' + this.options.transition);
	
	        // Find triggers that affect this element and add aria-expanded to them
	        this.$triggers = $(document).find('[data-open="' + id + '"], [data-close="' + id + '"], [data-toggle="' + id + '"]').attr('aria-expanded', 'false').attr('aria-controls', id);
	
	        // Add an overlay over the content if necessary
	        if (this.options.contentOverlay === true) {
	          var overlay = document.createElement('div');
	          var overlayPosition = $(this.$element).css("position") === 'fixed' ? 'is-overlay-fixed' : 'is-overlay-absolute';
	          overlay.setAttribute('class', 'js-off-canvas-overlay ' + overlayPosition);
	          this.$overlay = $(overlay);
	          if (overlayPosition === 'is-overlay-fixed') {
	            $('body').append(this.$overlay);
	          } else {
	            this.$element.siblings('[data-off-canvas-content]').append(this.$overlay);
	          }
	        }
	
	        this.options.isRevealed = this.options.isRevealed || new RegExp(this.options.revealClass, 'g').test(this.$element[0].className);
	
	        if (this.options.isRevealed === true) {
	          this.options.revealOn = this.options.revealOn || this.$element[0].className.match(/(reveal-for-medium|reveal-for-large)/g)[0].split('-')[2];
	          this._setMQChecker();
	        }
	        if (!this.options.transitionTime === true) {
	          this.options.transitionTime = parseFloat(window.getComputedStyle($('[data-off-canvas]')[0]).transitionDuration) * 1000;
	        }
	      }
	
	      /**
	       * Adds event handlers to the off-canvas wrapper and the exit overlay.
	       * @function
	       * @private
	       */
	
	    }, {
	      key: '_events',
	      value: function _events() {
	        this.$element.off('.zf.trigger .zf.offcanvas').on({
	          'open.zf.trigger': this.open.bind(this),
	          'close.zf.trigger': this.close.bind(this),
	          'toggle.zf.trigger': this.toggle.bind(this),
	          'keydown.zf.offcanvas': this._handleKeyboard.bind(this)
	        });
	
	        if (this.options.closeOnClick === true) {
	          var $target = this.options.contentOverlay ? this.$overlay : $('[data-off-canvas-content]');
	          $target.on({ 'click.zf.offcanvas': this.close.bind(this) });
	        }
	      }
	
	      /**
	       * Applies event listener for elements that will reveal at certain breakpoints.
	       * @private
	       */
	
	    }, {
	      key: '_setMQChecker',
	      value: function _setMQChecker() {
	        var _this = this;
	
	        $(window).on('changed.zf.mediaquery', function () {
	          if (Foundation.MediaQuery.atLeast(_this.options.revealOn)) {
	            _this.reveal(true);
	          } else {
	            _this.reveal(false);
	          }
	        }).one('load.zf.offcanvas', function () {
	          if (Foundation.MediaQuery.atLeast(_this.options.revealOn)) {
	            _this.reveal(true);
	          }
	        });
	      }
	
	      /**
	       * Handles the revealing/hiding the off-canvas at breakpoints, not the same as open.
	       * @param {Boolean} isRevealed - true if element should be revealed.
	       * @function
	       */
	
	    }, {
	      key: 'reveal',
	      value: function reveal(isRevealed) {
	        var $closer = this.$element.find('[data-close]');
	        if (isRevealed) {
	          this.close();
	          this.isRevealed = true;
	          this.$element.attr('aria-hidden', 'false');
	          this.$element.off('open.zf.trigger toggle.zf.trigger');
	          if ($closer.length) {
	            $closer.hide();
	          }
	        } else {
	          this.isRevealed = false;
	          this.$element.attr('aria-hidden', 'true');
	          this.$element.on({
	            'open.zf.trigger': this.open.bind(this),
	            'toggle.zf.trigger': this.toggle.bind(this)
	          });
	          if ($closer.length) {
	            $closer.show();
	          }
	        }
	      }
	
	      /**
	       * Stops scrolling of the body when offcanvas is open on mobile Safari and other troublesome browsers.
	       * @private
	       */
	
	    }, {
	      key: '_stopScrolling',
	      value: function _stopScrolling(event) {
	        return false;
	      }
	
	      // Taken and adapted from http://stackoverflow.com/questions/16889447/prevent-full-page-scrolling-ios
	      // Only really works for y, not sure how to extend to x or if we need to.
	
	    }, {
	      key: '_recordScrollable',
	      value: function _recordScrollable(event) {
	        var elem = this; // called from event handler context with this as elem
	
	        // If the element is scrollable (content overflows), then...
	        if (elem.scrollHeight !== elem.clientHeight) {
	          // If we're at the top, scroll down one pixel to allow scrolling up
	          if (elem.scrollTop === 0) {
	            elem.scrollTop = 1;
	          }
	          // If we're at the bottom, scroll up one pixel to allow scrolling down
	          if (elem.scrollTop === elem.scrollHeight - elem.clientHeight) {
	            elem.scrollTop = elem.scrollHeight - elem.clientHeight - 1;
	          }
	        }
	        elem.allowUp = elem.scrollTop > 0;
	        elem.allowDown = elem.scrollTop < elem.scrollHeight - elem.clientHeight;
	        elem.lastY = event.originalEvent.pageY;
	      }
	    }, {
	      key: '_stopScrollPropagation',
	      value: function _stopScrollPropagation(event) {
	        var elem = this; // called from event handler context with this as elem
	        var up = event.pageY < elem.lastY;
	        var down = !up;
	        elem.lastY = event.pageY;
	
	        if (up && elem.allowUp || down && elem.allowDown) {
	          event.stopPropagation();
	        } else {
	          event.preventDefault();
	        }
	      }
	
	      /**
	       * Opens the off-canvas menu.
	       * @function
	       * @param {Object} event - Event object passed from listener.
	       * @param {jQuery} trigger - element that triggered the off-canvas to open.
	       * @fires OffCanvas#opened
	       */
	
	    }, {
	      key: 'open',
	      value: function open(event, trigger) {
	        if (this.$element.hasClass('is-open') || this.isRevealed) {
	          return;
	        }
	        var _this = this;
	
	        if (trigger) {
	          this.$lastTrigger = trigger;
	        }
	
	        if (this.options.forceTo === 'top') {
	          window.scrollTo(0, 0);
	        } else if (this.options.forceTo === 'bottom') {
	          window.scrollTo(0, document.body.scrollHeight);
	        }
	
	        /**
	         * Fires when the off-canvas menu opens.
	         * @event OffCanvas#opened
	         */
	        _this.$element.addClass('is-open');
	
	        this.$triggers.attr('aria-expanded', 'true');
	        this.$element.attr('aria-hidden', 'false').trigger('opened.zf.offcanvas');
	
	        // If `contentScroll` is set to false, add class and disable scrolling on touch devices.
	        if (this.options.contentScroll === false) {
	          $('body').addClass('is-off-canvas-open').on('touchmove', this._stopScrolling);
	          this.$element.on('touchstart', this._recordScrollable);
	          this.$element.on('touchmove', this._stopScrollPropagation);
	        }
	
	        if (this.options.contentOverlay === true) {
	          this.$overlay.addClass('is-visible');
	        }
	
	        if (this.options.closeOnClick === true && this.options.contentOverlay === true) {
	          this.$overlay.addClass('is-closable');
	        }
	
	        if (this.options.autoFocus === true) {
	          this.$element.one(Foundation.transitionend(this.$element), function () {
	            _this.$element.find('a, button').eq(0).focus();
	          });
	        }
	
	        if (this.options.trapFocus === true) {
	          this.$element.siblings('[data-off-canvas-content]').attr('tabindex', '-1');
	          Foundation.Keyboard.trapFocus(this.$element);
	        }
	      }
	
	      /**
	       * Closes the off-canvas menu.
	       * @function
	       * @param {Function} cb - optional cb to fire after closure.
	       * @fires OffCanvas#closed
	       */
	
	    }, {
	      key: 'close',
	      value: function close(cb) {
	        if (!this.$element.hasClass('is-open') || this.isRevealed) {
	          return;
	        }
	
	        var _this = this;
	
	        _this.$element.removeClass('is-open');
	
	        this.$element.attr('aria-hidden', 'true')
	        /**
	         * Fires when the off-canvas menu opens.
	         * @event OffCanvas#closed
	         */
	        .trigger('closed.zf.offcanvas');
	
	        // If `contentScroll` is set to false, remove class and re-enable scrolling on touch devices.
	        if (this.options.contentScroll === false) {
	          $('body').removeClass('is-off-canvas-open').off('touchmove', this._stopScrolling);
	          this.$element.off('touchstart', this._recordScrollable);
	          this.$element.off('touchmove', this._stopScrollPropagation);
	        }
	
	        if (this.options.contentOverlay === true) {
	          this.$overlay.removeClass('is-visible');
	        }
	
	        if (this.options.closeOnClick === true && this.options.contentOverlay === true) {
	          this.$overlay.removeClass('is-closable');
	        }
	
	        this.$triggers.attr('aria-expanded', 'false');
	
	        if (this.options.trapFocus === true) {
	          this.$element.siblings('[data-off-canvas-content]').removeAttr('tabindex');
	          Foundation.Keyboard.releaseFocus(this.$element);
	        }
	      }
	
	      /**
	       * Toggles the off-canvas menu open or closed.
	       * @function
	       * @param {Object} event - Event object passed from listener.
	       * @param {jQuery} trigger - element that triggered the off-canvas to open.
	       */
	
	    }, {
	      key: 'toggle',
	      value: function toggle(event, trigger) {
	        if (this.$element.hasClass('is-open')) {
	          this.close(event, trigger);
	        } else {
	          this.open(event, trigger);
	        }
	      }
	
	      /**
	       * Handles keyboard input when detected. When the escape key is pressed, the off-canvas menu closes, and focus is restored to the element that opened the menu.
	       * @function
	       * @private
	       */
	
	    }, {
	      key: '_handleKeyboard',
	      value: function _handleKeyboard(e) {
	        var _this2 = this;
	
	        Foundation.Keyboard.handleKey(e, 'OffCanvas', {
	          close: function close() {
	            _this2.close();
	            _this2.$lastTrigger.focus();
	            return true;
	          },
	          handled: function handled() {
	            e.stopPropagation();
	            e.preventDefault();
	          }
	        });
	      }
	
	      /**
	       * Destroys the offcanvas plugin.
	       * @function
	       */
	
	    }, {
	      key: 'destroy',
	      value: function destroy() {
	        this.close();
	        this.$element.off('.zf.trigger .zf.offcanvas');
	        this.$overlay.off('.zf.offcanvas');
	
	        Foundation.unregisterPlugin(this);
	      }
	    }]);
	    return OffCanvas;
	  }();
	
	  OffCanvas.defaults = {
	    /**
	     * Allow the user to click outside of the menu to close it.
	     * @option
	     * @type {boolean}
	     * @default true
	     */
	    closeOnClick: true,
	
	    /**
	     * Adds an overlay on top of `[data-off-canvas-content]`.
	     * @option
	     * @type {boolean}
	     * @default true
	     */
	    contentOverlay: true,
	
	    /**
	     * Enable/disable scrolling of the main content when an off canvas panel is open.
	     * @option
	     * @type {boolean}
	     * @default true
	     */
	    contentScroll: true,
	
	    /**
	     * Amount of time in ms the open and close transition requires. If none selected, pulls from body style.
	     * @option
	     * @type {number}
	     * @default 0
	     */
	    transitionTime: 0,
	
	    /**
	     * Type of transition for the offcanvas menu. Options are 'push', 'detached' or 'slide'.
	     * @option
	     * @type {string}
	     * @default push
	     */
	    transition: 'push',
	
	    /**
	     * Force the page to scroll to top or bottom on open.
	     * @option
	     * @type {?string}
	     * @default null
	     */
	    forceTo: null,
	
	    /**
	     * Allow the offcanvas to remain open for certain breakpoints.
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    isRevealed: false,
	
	    /**
	     * Breakpoint at which to reveal. JS will use a RegExp to target standard classes, if changing classnames, pass your class with the `revealClass` option.
	     * @option
	     * @type {?string}
	     * @default null
	     */
	    revealOn: null,
	
	    /**
	     * Force focus to the offcanvas on open. If true, will focus the opening trigger on close.
	     * @option
	     * @type {boolean}
	     * @default true
	     */
	    autoFocus: true,
	
	    /**
	     * Class used to force an offcanvas to remain open. Foundation defaults for this are `reveal-for-large` & `reveal-for-medium`.
	     * @option
	     * @type {string}
	     * @default reveal-for-
	     * @todo improve the regex testing for this.
	     */
	    revealClass: 'reveal-for-',
	
	    /**
	     * Triggers optional focus trapping when opening an offcanvas. Sets tabindex of [data-off-canvas-content] to -1 for accessibility purposes.
	     * @option
	     * @type {boolean}
	     * @default false
	     */
	    trapFocus: false
	
	    // Window exports
	  };Foundation.plugin(OffCanvas, 'OffCanvas');
	}(jQuery);

/***/ }),
/* 163 */
/***/ (function(module, exports) {

	'use strict';
	
	!function ($) {
	
	  Foundation.Box = {
	    ImNotTouchingYou: ImNotTouchingYou,
	    GetDimensions: GetDimensions,
	    GetOffsets: GetOffsets
	
	    /**
	     * Compares the dimensions of an element to a container and determines collision events with container.
	     * @function
	     * @param {jQuery} element - jQuery object to test for collisions.
	     * @param {jQuery} parent - jQuery object to use as bounding container.
	     * @param {Boolean} lrOnly - set to true to check left and right values only.
	     * @param {Boolean} tbOnly - set to true to check top and bottom values only.
	     * @default if no parent object passed, detects collisions with `window`.
	     * @returns {Boolean} - true if collision free, false if a collision in any direction.
	     */
	  };function ImNotTouchingYou(element, parent, lrOnly, tbOnly) {
	    var eleDims = GetDimensions(element),
	        top,
	        bottom,
	        left,
	        right;
	
	    if (parent) {
	      var parDims = GetDimensions(parent);
	
	      bottom = eleDims.offset.top + eleDims.height <= parDims.height + parDims.offset.top;
	      top = eleDims.offset.top >= parDims.offset.top;
	      left = eleDims.offset.left >= parDims.offset.left;
	      right = eleDims.offset.left + eleDims.width <= parDims.width + parDims.offset.left;
	    } else {
	      bottom = eleDims.offset.top + eleDims.height <= eleDims.windowDims.height + eleDims.windowDims.offset.top;
	      top = eleDims.offset.top >= eleDims.windowDims.offset.top;
	      left = eleDims.offset.left >= eleDims.windowDims.offset.left;
	      right = eleDims.offset.left + eleDims.width <= eleDims.windowDims.width;
	    }
	
	    var allDirs = [bottom, top, left, right];
	
	    if (lrOnly) {
	      return left === right === true;
	    }
	
	    if (tbOnly) {
	      return top === bottom === true;
	    }
	
	    return allDirs.indexOf(false) === -1;
	  };
	
	  /**
	   * Uses native methods to return an object of dimension values.
	   * @function
	   * @param {jQuery || HTML} element - jQuery object or DOM element for which to get the dimensions. Can be any element other that document or window.
	   * @returns {Object} - nested object of integer pixel values
	   * TODO - if element is window, return only those values.
	   */
	  function GetDimensions(elem, test) {
	    elem = elem.length ? elem[0] : elem;
	
	    if (elem === window || elem === document) {
	      throw new Error("I'm sorry, Dave. I'm afraid I can't do that.");
	    }
	
	    var rect = elem.getBoundingClientRect(),
	        parRect = elem.parentNode.getBoundingClientRect(),
	        winRect = document.body.getBoundingClientRect(),
	        winY = window.pageYOffset,
	        winX = window.pageXOffset;
	
	    return {
	      width: rect.width,
	      height: rect.height,
	      offset: {
	        top: rect.top + winY,
	        left: rect.left + winX
	      },
	      parentDims: {
	        width: parRect.width,
	        height: parRect.height,
	        offset: {
	          top: parRect.top + winY,
	          left: parRect.left + winX
	        }
	      },
	      windowDims: {
	        width: winRect.width,
	        height: winRect.height,
	        offset: {
	          top: winY,
	          left: winX
	        }
	      }
	    };
	  }
	
	  /**
	   * Returns an object of top and left integer pixel values for dynamically rendered elements,
	   * such as: Tooltip, Reveal, and Dropdown
	   * @function
	   * @param {jQuery} element - jQuery object for the element being positioned.
	   * @param {jQuery} anchor - jQuery object for the element's anchor point.
	   * @param {String} position - a string relating to the desired position of the element, relative to it's anchor
	   * @param {Number} vOffset - integer pixel value of desired vertical separation between anchor and element.
	   * @param {Number} hOffset - integer pixel value of desired horizontal separation between anchor and element.
	   * @param {Boolean} isOverflow - if a collision event is detected, sets to true to default the element to full width - any desired offset.
	   * TODO alter/rewrite to work with `em` values as well/instead of pixels
	   */
	  function GetOffsets(element, anchor, position, vOffset, hOffset, isOverflow) {
	    var $eleDims = GetDimensions(element),
	        $anchorDims = anchor ? GetDimensions(anchor) : null;
	
	    switch (position) {
	      case 'top':
	        return {
	          left: Foundation.rtl() ? $anchorDims.offset.left - $eleDims.width + $anchorDims.width : $anchorDims.offset.left,
	          top: $anchorDims.offset.top - ($eleDims.height + vOffset)
	        };
	        break;
	      case 'left':
	        return {
	          left: $anchorDims.offset.left - ($eleDims.width + hOffset),
	          top: $anchorDims.offset.top
	        };
	        break;
	      case 'right':
	        return {
	          left: $anchorDims.offset.left + $anchorDims.width + hOffset,
	          top: $anchorDims.offset.top
	        };
	        break;
	      case 'center top':
	        return {
	          left: $anchorDims.offset.left + $anchorDims.width / 2 - $eleDims.width / 2,
	          top: $anchorDims.offset.top - ($eleDims.height + vOffset)
	        };
	        break;
	      case 'center bottom':
	        return {
	          left: isOverflow ? hOffset : $anchorDims.offset.left + $anchorDims.width / 2 - $eleDims.width / 2,
	          top: $anchorDims.offset.top + $anchorDims.height + vOffset
	        };
	        break;
	      case 'center left':
	        return {
	          left: $anchorDims.offset.left - ($eleDims.width + hOffset),
	          top: $anchorDims.offset.top + $anchorDims.height / 2 - $eleDims.height / 2
	        };
	        break;
	      case 'center right':
	        return {
	          left: $anchorDims.offset.left + $anchorDims.width + hOffset + 1,
	          top: $anchorDims.offset.top + $anchorDims.height / 2 - $eleDims.height / 2
	        };
	        break;
	      case 'center':
	        return {
	          left: $eleDims.windowDims.offset.left + $eleDims.windowDims.width / 2 - $eleDims.width / 2,
	          top: $eleDims.windowDims.offset.top + $eleDims.windowDims.height / 2 - $eleDims.height / 2
	        };
	        break;
	      case 'reveal':
	        return {
	          left: ($eleDims.windowDims.width - $eleDims.width) / 2,
	          top: $eleDims.windowDims.offset.top + vOffset
	        };
	      case 'reveal full':
	        return {
	          left: $eleDims.windowDims.offset.left,
	          top: $eleDims.windowDims.offset.top
	        };
	        break;
	      case 'left bottom':
	        return {
	          left: $anchorDims.offset.left,
	          top: $anchorDims.offset.top + $anchorDims.height + vOffset
	        };
	        break;
	      case 'right bottom':
	        return {
	          left: $anchorDims.offset.left + $anchorDims.width + hOffset - $eleDims.width,
	          top: $anchorDims.offset.top + $anchorDims.height + vOffset
	        };
	        break;
	      default:
	        return {
	          left: Foundation.rtl() ? $anchorDims.offset.left - $eleDims.width + $anchorDims.width : $anchorDims.offset.left + hOffset,
	          top: $anchorDims.offset.top + $anchorDims.height + vOffset
	        };
	    }
	  }
	}(jQuery);

/***/ }),
/* 164 */
/***/ (function(module, exports) {

	/*******************************************
	 *                                         *
	 * This util was created by Marius Olbertz *
	 * Please thank Marius on GitHub /owlbertz *
	 * or the web http://www.mariusolbertz.de/ *
	 *                                         *
	 ******************************************/
	
	'use strict';
	
	!function ($) {
	
	  var keyCodes = {
	    9: 'TAB',
	    13: 'ENTER',
	    27: 'ESCAPE',
	    32: 'SPACE',
	    37: 'ARROW_LEFT',
	    38: 'ARROW_UP',
	    39: 'ARROW_RIGHT',
	    40: 'ARROW_DOWN'
	  };
	
	  var commands = {};
	
	  var Keyboard = {
	    keys: getKeyCodes(keyCodes),
	
	    /**
	     * Parses the (keyboard) event and returns a String that represents its key
	     * Can be used like Foundation.parseKey(event) === Foundation.keys.SPACE
	     * @param {Event} event - the event generated by the event handler
	     * @return String key - String that represents the key pressed
	     */
	    parseKey: function parseKey(event) {
	      var key = keyCodes[event.which || event.keyCode] || String.fromCharCode(event.which).toUpperCase();
	
	      // Remove un-printable characters, e.g. for `fromCharCode` calls for CTRL only events
	      key = key.replace(/\W+/, '');
	
	      if (event.shiftKey) key = 'SHIFT_' + key;
	      if (event.ctrlKey) key = 'CTRL_' + key;
	      if (event.altKey) key = 'ALT_' + key;
	
	      // Remove trailing underscore, in case only modifiers were used (e.g. only `CTRL_ALT`)
	      key = key.replace(/_$/, '');
	
	      return key;
	    },
	
	
	    /**
	     * Handles the given (keyboard) event
	     * @param {Event} event - the event generated by the event handler
	     * @param {String} component - Foundation component's name, e.g. Slider or Reveal
	     * @param {Objects} functions - collection of functions that are to be executed
	     */
	    handleKey: function handleKey(event, component, functions) {
	      var commandList = commands[component],
	          keyCode = this.parseKey(event),
	          cmds,
	          command,
	          fn;
	
	      if (!commandList) return console.warn('Component not defined!');
	
	      if (typeof commandList.ltr === 'undefined') {
	        // this component does not differentiate between ltr and rtl
	        cmds = commandList; // use plain list
	      } else {
	        // merge ltr and rtl: if document is rtl, rtl overwrites ltr and vice versa
	        if (Foundation.rtl()) cmds = $.extend({}, commandList.ltr, commandList.rtl);else cmds = $.extend({}, commandList.rtl, commandList.ltr);
	      }
	      command = cmds[keyCode];
	
	      fn = functions[command];
	      if (fn && typeof fn === 'function') {
	        // execute function  if exists
	        var returnValue = fn.apply();
	        if (functions.handled || typeof functions.handled === 'function') {
	          // execute function when event was handled
	          functions.handled(returnValue);
	        }
	      } else {
	        if (functions.unhandled || typeof functions.unhandled === 'function') {
	          // execute function when event was not handled
	          functions.unhandled();
	        }
	      }
	    },
	
	
	    /**
	     * Finds all focusable elements within the given `$element`
	     * @param {jQuery} $element - jQuery object to search within
	     * @return {jQuery} $focusable - all focusable elements within `$element`
	     */
	    findFocusable: function findFocusable($element) {
	      if (!$element) {
	        return false;
	      }
	      return $element.find('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]').filter(function () {
	        if (!$(this).is(':visible') || $(this).attr('tabindex') < 0) {
	          return false;
	        } //only have visible elements and those that have a tabindex greater or equal 0
	        return true;
	      });
	    },
	
	
	    /**
	     * Returns the component name name
	     * @param {Object} component - Foundation component, e.g. Slider or Reveal
	     * @return String componentName
	     */
	
	    register: function register(componentName, cmds) {
	      commands[componentName] = cmds;
	    },
	
	
	    /**
	     * Traps the focus in the given element.
	     * @param  {jQuery} $element  jQuery object to trap the foucs into.
	     */
	    trapFocus: function trapFocus($element) {
	      var $focusable = Foundation.Keyboard.findFocusable($element),
	          $firstFocusable = $focusable.eq(0),
	          $lastFocusable = $focusable.eq(-1);
	
	      $element.on('keydown.zf.trapfocus', function (event) {
	        if (event.target === $lastFocusable[0] && Foundation.Keyboard.parseKey(event) === 'TAB') {
	          event.preventDefault();
	          $firstFocusable.focus();
	        } else if (event.target === $firstFocusable[0] && Foundation.Keyboard.parseKey(event) === 'SHIFT_TAB') {
	          event.preventDefault();
	          $lastFocusable.focus();
	        }
	      });
	    },
	
	    /**
	     * Releases the trapped focus from the given element.
	     * @param  {jQuery} $element  jQuery object to release the focus for.
	     */
	    releaseFocus: function releaseFocus($element) {
	      $element.off('keydown.zf.trapfocus');
	    }
	  };
	
	  /*
	   * Constants for easier comparing.
	   * Can be used like Foundation.parseKey(event) === Foundation.keys.SPACE
	   */
	  function getKeyCodes(kcs) {
	    var k = {};
	    for (var kc in kcs) {
	      k[kcs[kc]] = kcs[kc];
	    }return k;
	  }
	
	  Foundation.Keyboard = Keyboard;
	}(jQuery);

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof2 = __webpack_require__(48);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	!function ($) {
	
	  // Default set of media queries
	  var defaultQueries = {
	    'default': 'only screen',
	    landscape: 'only screen and (orientation: landscape)',
	    portrait: 'only screen and (orientation: portrait)',
	    retina: 'only screen and (-webkit-min-device-pixel-ratio: 2),' + 'only screen and (min--moz-device-pixel-ratio: 2),' + 'only screen and (-o-min-device-pixel-ratio: 2/1),' + 'only screen and (min-device-pixel-ratio: 2),' + 'only screen and (min-resolution: 192dpi),' + 'only screen and (min-resolution: 2dppx)'
	  };
	
	  var MediaQuery = {
	    queries: [],
	
	    current: '',
	
	    /**
	     * Initializes the media query helper, by extracting the breakpoint list from the CSS and activating the breakpoint watcher.
	     * @function
	     * @private
	     */
	    _init: function _init() {
	      var self = this;
	      var extractedStyles = $('.foundation-mq').css('font-family');
	      var namedQueries;
	
	      namedQueries = parseStyleToObject(extractedStyles);
	
	      for (var key in namedQueries) {
	        if (namedQueries.hasOwnProperty(key)) {
	          self.queries.push({
	            name: key,
	            value: 'only screen and (min-width: ' + namedQueries[key] + ')'
	          });
	        }
	      }
	
	      this.current = this._getCurrentSize();
	
	      this._watcher();
	    },
	
	
	    /**
	     * Checks if the screen is at least as wide as a breakpoint.
	     * @function
	     * @param {String} size - Name of the breakpoint to check.
	     * @returns {Boolean} `true` if the breakpoint matches, `false` if it's smaller.
	     */
	    atLeast: function atLeast(size) {
	      var query = this.get(size);
	
	      if (query) {
	        return window.matchMedia(query).matches;
	      }
	
	      return false;
	    },
	
	
	    /**
	     * Checks if the screen matches to a breakpoint.
	     * @function
	     * @param {String} size - Name of the breakpoint to check, either 'small only' or 'small'. Omitting 'only' falls back to using atLeast() method.
	     * @returns {Boolean} `true` if the breakpoint matches, `false` if it does not.
	     */
	    is: function is(size) {
	      size = size.trim().split(' ');
	      if (size.length > 1 && size[1] === 'only') {
	        if (size[0] === this._getCurrentSize()) return true;
	      } else {
	        return this.atLeast(size[0]);
	      }
	      return false;
	    },
	
	
	    /**
	     * Gets the media query of a breakpoint.
	     * @function
	     * @param {String} size - Name of the breakpoint to get.
	     * @returns {String|null} - The media query of the breakpoint, or `null` if the breakpoint doesn't exist.
	     */
	    get: function get(size) {
	      for (var i in this.queries) {
	        if (this.queries.hasOwnProperty(i)) {
	          var query = this.queries[i];
	          if (size === query.name) return query.value;
	        }
	      }
	
	      return null;
	    },
	
	
	    /**
	     * Gets the current breakpoint name by testing every breakpoint and returning the last one to match (the biggest one).
	     * @function
	     * @private
	     * @returns {String} Name of the current breakpoint.
	     */
	    _getCurrentSize: function _getCurrentSize() {
	      var matched;
	
	      for (var i = 0; i < this.queries.length; i++) {
	        var query = this.queries[i];
	
	        if (window.matchMedia(query.value).matches) {
	          matched = query;
	        }
	      }
	
	      if ((typeof matched === 'undefined' ? 'undefined' : (0, _typeof3.default)(matched)) === 'object') {
	        return matched.name;
	      } else {
	        return matched;
	      }
	    },
	
	
	    /**
	     * Activates the breakpoint watcher, which fires an event on the window whenever the breakpoint changes.
	     * @function
	     * @private
	     */
	    _watcher: function _watcher() {
	      var _this = this;
	
	      $(window).on('resize.zf.mediaquery', function () {
	        var newSize = _this._getCurrentSize(),
	            currentSize = _this.current;
	
	        if (newSize !== currentSize) {
	          // Change the current media query
	          _this.current = newSize;
	
	          // Broadcast the media query change on the window
	          $(window).trigger('changed.zf.mediaquery', [newSize, currentSize]);
	        }
	      });
	    }
	  };
	
	  Foundation.MediaQuery = MediaQuery;
	
	  // matchMedia() polyfill - Test a CSS media type/query in JS.
	  // Authors & copyright (c) 2012: Scott Jehl, Paul Irish, Nicholas Zakas, David Knight. Dual MIT/BSD license
	  window.matchMedia || (window.matchMedia = function () {
	    'use strict';
	
	    // For browsers that support matchMedium api such as IE 9 and webkit
	
	    var styleMedia = window.styleMedia || window.media;
	
	    // For those that don't support matchMedium
	    if (!styleMedia) {
	      var style = document.createElement('style'),
	          script = document.getElementsByTagName('script')[0],
	          info = null;
	
	      style.type = 'text/css';
	      style.id = 'matchmediajs-test';
	
	      script && script.parentNode && script.parentNode.insertBefore(style, script);
	
	      // 'style.currentStyle' is used by IE <= 8 and 'window.getComputedStyle' for all other browsers
	      info = 'getComputedStyle' in window && window.getComputedStyle(style, null) || style.currentStyle;
	
	      styleMedia = {
	        matchMedium: function matchMedium(media) {
	          var text = '@media ' + media + '{ #matchmediajs-test { width: 1px; } }';
	
	          // 'style.styleSheet' is used by IE <= 8 and 'style.textContent' for all other browsers
	          if (style.styleSheet) {
	            style.styleSheet.cssText = text;
	          } else {
	            style.textContent = text;
	          }
	
	          // Test if media query is true or false
	          return info.width === '1px';
	        }
	      };
	    }
	
	    return function (media) {
	      return {
	        matches: styleMedia.matchMedium(media || 'all'),
	        media: media || 'all'
	      };
	    };
	  }());
	
	  // Thank you: https://github.com/sindresorhus/query-string
	  function parseStyleToObject(str) {
	    var styleObject = {};
	
	    if (typeof str !== 'string') {
	      return styleObject;
	    }
	
	    str = str.trim().slice(1, -1); // browsers re-quote string style values
	
	    if (!str) {
	      return styleObject;
	    }
	
	    styleObject = str.split('&').reduce(function (ret, param) {
	      var parts = param.replace(/\+/g, ' ').split('=');
	      var key = parts[0];
	      var val = parts[1];
	      key = decodeURIComponent(key);
	
	      // missing `=` should be `null`:
	      // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
	      val = val === undefined ? null : decodeURIComponent(val);
	
	      if (!ret.hasOwnProperty(key)) {
	        ret[key] = val;
	      } else if (Array.isArray(ret[key])) {
	        ret[key].push(val);
	      } else {
	        ret[key] = [ret[key], val];
	      }
	      return ret;
	    }, {});
	
	    return styleObject;
	  }
	
	  Foundation.MediaQuery = MediaQuery;
	}(jQuery);

/***/ }),
/* 166 */
/***/ (function(module, exports) {

	'use strict';
	
	!function ($) {
	
	  /**
	   * Motion module.
	   * @module foundation.motion
	   */
	
	  var initClasses = ['mui-enter', 'mui-leave'];
	  var activeClasses = ['mui-enter-active', 'mui-leave-active'];
	
	  var Motion = {
	    animateIn: function animateIn(element, animation, cb) {
	      animate(true, element, animation, cb);
	    },
	
	    animateOut: function animateOut(element, animation, cb) {
	      animate(false, element, animation, cb);
	    }
	  };
	
	  function Move(duration, elem, fn) {
	    var anim,
	        prog,
	        start = null;
	    // console.log('called');
	
	    if (duration === 0) {
	      fn.apply(elem);
	      elem.trigger('finished.zf.animate', [elem]).triggerHandler('finished.zf.animate', [elem]);
	      return;
	    }
	
	    function move(ts) {
	      if (!start) start = ts;
	      // console.log(start, ts);
	      prog = ts - start;
	      fn.apply(elem);
	
	      if (prog < duration) {
	        anim = window.requestAnimationFrame(move, elem);
	      } else {
	        window.cancelAnimationFrame(anim);
	        elem.trigger('finished.zf.animate', [elem]).triggerHandler('finished.zf.animate', [elem]);
	      }
	    }
	    anim = window.requestAnimationFrame(move);
	  }
	
	  /**
	   * Animates an element in or out using a CSS transition class.
	   * @function
	   * @private
	   * @param {Boolean} isIn - Defines if the animation is in or out.
	   * @param {Object} element - jQuery or HTML object to animate.
	   * @param {String} animation - CSS class to use.
	   * @param {Function} cb - Callback to run when animation is finished.
	   */
	  function animate(isIn, element, animation, cb) {
	    element = $(element).eq(0);
	
	    if (!element.length) return;
	
	    var initClass = isIn ? initClasses[0] : initClasses[1];
	    var activeClass = isIn ? activeClasses[0] : activeClasses[1];
	
	    // Set up the animation
	    reset();
	
	    element.addClass(animation).css('transition', 'none');
	
	    requestAnimationFrame(function () {
	      element.addClass(initClass);
	      if (isIn) element.show();
	    });
	
	    // Start the animation
	    requestAnimationFrame(function () {
	      element[0].offsetWidth;
	      element.css('transition', '').addClass(activeClass);
	    });
	
	    // Clean up the animation when it finishes
	    element.one(Foundation.transitionend(element), finish);
	
	    // Hides the element (for out animations), resets the element, and runs a callback
	    function finish() {
	      if (!isIn) element.hide();
	      reset();
	      if (cb) cb.apply(element);
	    }
	
	    // Resets transitions and removes motion-specific classes
	    function reset() {
	      element[0].style.transitionDuration = 0;
	      element.removeClass(initClass + ' ' + activeClass + ' ' + animation);
	    }
	  }
	
	  Foundation.Move = Move;
	  Foundation.Motion = Motion;
	}(jQuery);

/***/ }),
/* 167 */
/***/ (function(module, exports) {

	'use strict';
	
	!function ($) {
	
	  var Nest = {
	    Feather: function Feather(menu) {
	      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'zf';
	
	      menu.attr('role', 'menubar');
	
	      var items = menu.find('li').attr({ 'role': 'menuitem' }),
	          subMenuClass = 'is-' + type + '-submenu',
	          subItemClass = subMenuClass + '-item',
	          hasSubClass = 'is-' + type + '-submenu-parent';
	
	      items.each(function () {
	        var $item = $(this),
	            $sub = $item.children('ul');
	
	        if ($sub.length) {
	          $item.addClass(hasSubClass).attr({
	            'aria-haspopup': true,
	            'aria-label': $item.children('a:first').text()
	          });
	          // Note:  Drilldowns behave differently in how they hide, and so need
	          // additional attributes.  We should look if this possibly over-generalized
	          // utility (Nest) is appropriate when we rework menus in 6.4
	          if (type === 'drilldown') {
	            $item.attr({ 'aria-expanded': false });
	          }
	
	          $sub.addClass('submenu ' + subMenuClass).attr({
	            'data-submenu': '',
	            'role': 'menu'
	          });
	          if (type === 'drilldown') {
	            $sub.attr({ 'aria-hidden': true });
	          }
	        }
	
	        if ($item.parent('[data-submenu]').length) {
	          $item.addClass('is-submenu-item ' + subItemClass);
	        }
	      });
	
	      return;
	    },
	    Burn: function Burn(menu, type) {
	      var //items = menu.find('li'),
	      subMenuClass = 'is-' + type + '-submenu',
	          subItemClass = subMenuClass + '-item',
	          hasSubClass = 'is-' + type + '-submenu-parent';
	
	      menu.find('>li, .menu, .menu > li').removeClass(subMenuClass + ' ' + subItemClass + ' ' + hasSubClass + ' is-submenu-item submenu is-active').removeAttr('data-submenu').css('display', '');
	
	      // console.log(      menu.find('.' + subMenuClass + ', .' + subItemClass + ', .has-submenu, .is-submenu-item, .submenu, [data-submenu]')
	      //           .removeClass(subMenuClass + ' ' + subItemClass + ' has-submenu is-submenu-item submenu')
	      //           .removeAttr('data-submenu'));
	      // items.each(function(){
	      //   var $item = $(this),
	      //       $sub = $item.children('ul');
	      //   if($item.parent('[data-submenu]').length){
	      //     $item.removeClass('is-submenu-item ' + subItemClass);
	      //   }
	      //   if($sub.length){
	      //     $item.removeClass('has-submenu');
	      //     $sub.removeClass('submenu ' + subMenuClass).removeAttr('data-submenu');
	      //   }
	      // });
	    }
	  };
	
	  Foundation.Nest = Nest;
	}(jQuery);

/***/ }),
/* 168 */
/***/ (function(module, exports) {

	'use strict';
	
	//**************************************************
	//**Work inspired by multiple jquery swipe plugins**
	//**Done by Yohai Ararat ***************************
	//**************************************************
	(function ($) {
	
		$.spotSwipe = {
			version: '1.0.0',
			enabled: 'ontouchstart' in document.documentElement,
			preventDefault: false,
			moveThreshold: 75,
			timeThreshold: 200
		};
	
		var startPosX,
		    startPosY,
		    startTime,
		    elapsedTime,
		    isMoving = false;
	
		function onTouchEnd() {
			//  alert(this);
			this.removeEventListener('touchmove', onTouchMove);
			this.removeEventListener('touchend', onTouchEnd);
			isMoving = false;
		}
	
		function onTouchMove(e) {
			if ($.spotSwipe.preventDefault) {
				e.preventDefault();
			}
			if (isMoving) {
				var x = e.touches[0].pageX;
				var y = e.touches[0].pageY;
				var dx = startPosX - x;
				var dy = startPosY - y;
				var dir;
				elapsedTime = new Date().getTime() - startTime;
				if (Math.abs(dx) >= $.spotSwipe.moveThreshold && elapsedTime <= $.spotSwipe.timeThreshold) {
					dir = dx > 0 ? 'left' : 'right';
				}
				// else if(Math.abs(dy) >= $.spotSwipe.moveThreshold && elapsedTime <= $.spotSwipe.timeThreshold) {
				//   dir = dy > 0 ? 'down' : 'up';
				// }
				if (dir) {
					e.preventDefault();
					onTouchEnd.call(this);
					$(this).trigger('swipe', dir).trigger('swipe' + dir);
				}
			}
		}
	
		function onTouchStart(e) {
			if (e.touches.length == 1) {
				startPosX = e.touches[0].pageX;
				startPosY = e.touches[0].pageY;
				isMoving = true;
				startTime = new Date().getTime();
				this.addEventListener('touchmove', onTouchMove, false);
				this.addEventListener('touchend', onTouchEnd, false);
			}
		}
	
		function init() {
			this.addEventListener && this.addEventListener('touchstart', onTouchStart, false);
		}
	
		function teardown() {
			this.removeEventListener('touchstart', onTouchStart);
		}
	
		$.event.special.swipe = { setup: init };
	
		$.each(['left', 'up', 'down', 'right'], function () {
			$.event.special['swipe' + this] = { setup: function setup() {
					$(this).on('swipe', $.noop);
				} };
		});
	})(jQuery);
	/****************************************************
	 * Method for adding psuedo drag events to elements *
	 ***************************************************/
	!function ($) {
		$.fn.addTouch = function () {
			this.each(function (i, el) {
				$(el).bind('touchstart touchmove touchend touchcancel', function () {
					//we pass the original event object because the jQuery event
					//object is normalized to w3c specs and does not provide the TouchList
					handleTouch(event);
				});
			});
	
			var handleTouch = function handleTouch(event) {
				var touches = event.changedTouches,
				    first = touches[0],
				    eventTypes = {
					touchstart: 'mousedown',
					touchmove: 'mousemove',
					touchend: 'mouseup'
				},
				    type = eventTypes[event.type],
				    simulatedEvent;
	
				if ('MouseEvent' in window && typeof window.MouseEvent === 'function') {
					simulatedEvent = new window.MouseEvent(type, {
						'bubbles': true,
						'cancelable': true,
						'screenX': first.screenX,
						'screenY': first.screenY,
						'clientX': first.clientX,
						'clientY': first.clientY
					});
				} else {
					simulatedEvent = document.createEvent('MouseEvent');
					simulatedEvent.initMouseEvent(type, true, true, window, 1, first.screenX, first.screenY, first.clientX, first.clientY, false, false, false, false, 0 /*left*/, null);
				}
				first.target.dispatchEvent(simulatedEvent);
			};
		};
	}(jQuery);
	
	//**********************************
	//**From the jQuery Mobile Library**
	//**need to recreate functionality**
	//**and try to improve if possible**
	//**********************************
	
	/* Removing the jQuery function ****
	************************************

	(function( $, window, undefined ) {

		var $document = $( document ),
			// supportTouch = $.mobile.support.touch,
			touchStartEvent = 'touchstart'//supportTouch ? "touchstart" : "mousedown",
			touchStopEvent = 'touchend'//supportTouch ? "touchend" : "mouseup",
			touchMoveEvent = 'touchmove'//supportTouch ? "touchmove" : "mousemove";

		// setup new event shortcuts
		$.each( ( "touchstart touchmove touchend " +
			"swipe swipeleft swiperight" ).split( " " ), function( i, name ) {

			$.fn[ name ] = function( fn ) {
				return fn ? this.bind( name, fn ) : this.trigger( name );
			};

			// jQuery < 1.8
			if ( $.attrFn ) {
				$.attrFn[ name ] = true;
			}
		});

		function triggerCustomEvent( obj, eventType, event, bubble ) {
			var originalType = event.type;
			event.type = eventType;
			if ( bubble ) {
				$.event.trigger( event, undefined, obj );
			} else {
				$.event.dispatch.call( obj, event );
			}
			event.type = originalType;
		}

		// also handles taphold

		// Also handles swipeleft, swiperight
		$.event.special.swipe = {

			// More than this horizontal displacement, and we will suppress scrolling.
			scrollSupressionThreshold: 30,

			// More time than this, and it isn't a swipe.
			durationThreshold: 1000,

			// Swipe horizontal displacement must be more than this.
			horizontalDistanceThreshold: window.devicePixelRatio >= 2 ? 15 : 30,

			// Swipe vertical displacement must be less than this.
			verticalDistanceThreshold: window.devicePixelRatio >= 2 ? 15 : 30,

			getLocation: function ( event ) {
				var winPageX = window.pageXOffset,
					winPageY = window.pageYOffset,
					x = event.clientX,
					y = event.clientY;

				if ( event.pageY === 0 && Math.floor( y ) > Math.floor( event.pageY ) ||
					event.pageX === 0 && Math.floor( x ) > Math.floor( event.pageX ) ) {

					// iOS4 clientX/clientY have the value that should have been
					// in pageX/pageY. While pageX/page/ have the value 0
					x = x - winPageX;
					y = y - winPageY;
				} else if ( y < ( event.pageY - winPageY) || x < ( event.pageX - winPageX ) ) {

					// Some Android browsers have totally bogus values for clientX/Y
					// when scrolling/zooming a page. Detectable since clientX/clientY
					// should never be smaller than pageX/pageY minus page scroll
					x = event.pageX - winPageX;
					y = event.pageY - winPageY;
				}

				return {
					x: x,
					y: y
				};
			},

			start: function( event ) {
				var data = event.originalEvent.touches ?
						event.originalEvent.touches[ 0 ] : event,
					location = $.event.special.swipe.getLocation( data );
				return {
							time: ( new Date() ).getTime(),
							coords: [ location.x, location.y ],
							origin: $( event.target )
						};
			},

			stop: function( event ) {
				var data = event.originalEvent.touches ?
						event.originalEvent.touches[ 0 ] : event,
					location = $.event.special.swipe.getLocation( data );
				return {
							time: ( new Date() ).getTime(),
							coords: [ location.x, location.y ]
						};
			},

			handleSwipe: function( start, stop, thisObject, origTarget ) {
				if ( stop.time - start.time < $.event.special.swipe.durationThreshold &&
					Math.abs( start.coords[ 0 ] - stop.coords[ 0 ] ) > $.event.special.swipe.horizontalDistanceThreshold &&
					Math.abs( start.coords[ 1 ] - stop.coords[ 1 ] ) < $.event.special.swipe.verticalDistanceThreshold ) {
					var direction = start.coords[0] > stop.coords[ 0 ] ? "swipeleft" : "swiperight";

					triggerCustomEvent( thisObject, "swipe", $.Event( "swipe", { target: origTarget, swipestart: start, swipestop: stop }), true );
					triggerCustomEvent( thisObject, direction,$.Event( direction, { target: origTarget, swipestart: start, swipestop: stop } ), true );
					return true;
				}
				return false;

			},

			// This serves as a flag to ensure that at most one swipe event event is
			// in work at any given time
			eventInProgress: false,

			setup: function() {
				var events,
					thisObject = this,
					$this = $( thisObject ),
					context = {};

				// Retrieve the events data for this element and add the swipe context
				events = $.data( this, "mobile-events" );
				if ( !events ) {
					events = { length: 0 };
					$.data( this, "mobile-events", events );
				}
				events.length++;
				events.swipe = context;

				context.start = function( event ) {

					// Bail if we're already working on a swipe event
					if ( $.event.special.swipe.eventInProgress ) {
						return;
					}
					$.event.special.swipe.eventInProgress = true;

					var stop,
						start = $.event.special.swipe.start( event ),
						origTarget = event.target,
						emitted = false;

					context.move = function( event ) {
						if ( !start || event.isDefaultPrevented() ) {
							return;
						}

						stop = $.event.special.swipe.stop( event );
						if ( !emitted ) {
							emitted = $.event.special.swipe.handleSwipe( start, stop, thisObject, origTarget );
							if ( emitted ) {

								// Reset the context to make way for the next swipe event
								$.event.special.swipe.eventInProgress = false;
							}
						}
						// prevent scrolling
						if ( Math.abs( start.coords[ 0 ] - stop.coords[ 0 ] ) > $.event.special.swipe.scrollSupressionThreshold ) {
							event.preventDefault();
						}
					};

					context.stop = function() {
							emitted = true;

							// Reset the context to make way for the next swipe event
							$.event.special.swipe.eventInProgress = false;
							$document.off( touchMoveEvent, context.move );
							context.move = null;
					};

					$document.on( touchMoveEvent, context.move )
						.one( touchStopEvent, context.stop );
				};
				$this.on( touchStartEvent, context.start );
			},

			teardown: function() {
				var events, context;

				events = $.data( this, "mobile-events" );
				if ( events ) {
					context = events.swipe;
					delete events.swipe;
					events.length--;
					if ( events.length === 0 ) {
						$.removeData( this, "mobile-events" );
					}
				}

				if ( context ) {
					if ( context.start ) {
						$( this ).off( touchStartEvent, context.start );
					}
					if ( context.move ) {
						$document.off( touchMoveEvent, context.move );
					}
					if ( context.stop ) {
						$document.off( touchStopEvent, context.stop );
					}
				}
			}
		};
		$.each({
			swipeleft: "swipe.left",
			swiperight: "swipe.right"
		}, function( event, sourceEvent ) {

			$.event.special[ event ] = {
				setup: function() {
					$( this ).bind( sourceEvent, $.noop );
				},
				teardown: function() {
					$( this ).unbind( sourceEvent );
				}
			};
		});
	})( jQuery, this );
	*/

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof2 = __webpack_require__(48);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	!function ($) {
	
	  var MutationObserver = function () {
	    var prefixes = ['WebKit', 'Moz', 'O', 'Ms', ''];
	    for (var i = 0; i < prefixes.length; i++) {
	      if (prefixes[i] + 'MutationObserver' in window) {
	        return window[prefixes[i] + 'MutationObserver'];
	      }
	    }
	    return false;
	  }();
	
	  var triggers = function triggers(el, type) {
	    el.data(type).split(' ').forEach(function (id) {
	      $('#' + id)[type === 'close' ? 'trigger' : 'triggerHandler'](type + '.zf.trigger', [el]);
	    });
	  };
	  // Elements with [data-open] will reveal a plugin that supports it when clicked.
	  $(document).on('click.zf.trigger', '[data-open]', function () {
	    triggers($(this), 'open');
	  });
	
	  // Elements with [data-close] will close a plugin that supports it when clicked.
	  // If used without a value on [data-close], the event will bubble, allowing it to close a parent component.
	  $(document).on('click.zf.trigger', '[data-close]', function () {
	    var id = $(this).data('close');
	    if (id) {
	      triggers($(this), 'close');
	    } else {
	      $(this).trigger('close.zf.trigger');
	    }
	  });
	
	  // Elements with [data-toggle] will toggle a plugin that supports it when clicked.
	  $(document).on('click.zf.trigger', '[data-toggle]', function () {
	    var id = $(this).data('toggle');
	    if (id) {
	      triggers($(this), 'toggle');
	    } else {
	      $(this).trigger('toggle.zf.trigger');
	    }
	  });
	
	  // Elements with [data-closable] will respond to close.zf.trigger events.
	  $(document).on('close.zf.trigger', '[data-closable]', function (e) {
	    e.stopPropagation();
	    var animation = $(this).data('closable');
	
	    if (animation !== '') {
	      Foundation.Motion.animateOut($(this), animation, function () {
	        $(this).trigger('closed.zf');
	      });
	    } else {
	      $(this).fadeOut().trigger('closed.zf');
	    }
	  });
	
	  $(document).on('focus.zf.trigger blur.zf.trigger', '[data-toggle-focus]', function () {
	    var id = $(this).data('toggle-focus');
	    $('#' + id).triggerHandler('toggle.zf.trigger', [$(this)]);
	  });
	
	  /**
	  * Fires once after all other scripts have loaded
	  * @function
	  * @private
	  */
	  $(window).on('load', function () {
	    checkListeners();
	  });
	
	  function checkListeners() {
	    eventsListener();
	    resizeListener();
	    scrollListener();
	    mutateListener();
	    closemeListener();
	  }
	
	  //******** only fires this function once on load, if there's something to watch ********
	  function closemeListener(pluginName) {
	    var yetiBoxes = $('[data-yeti-box]'),
	        plugNames = ['dropdown', 'tooltip', 'reveal'];
	
	    if (pluginName) {
	      if (typeof pluginName === 'string') {
	        plugNames.push(pluginName);
	      } else if ((typeof pluginName === 'undefined' ? 'undefined' : (0, _typeof3.default)(pluginName)) === 'object' && typeof pluginName[0] === 'string') {
	        plugNames.concat(pluginName);
	      } else {
	        console.error('Plugin names must be strings');
	      }
	    }
	    if (yetiBoxes.length) {
	      var listeners = plugNames.map(function (name) {
	        return 'closeme.zf.' + name;
	      }).join(' ');
	
	      $(window).off(listeners).on(listeners, function (e, pluginId) {
	        var plugin = e.namespace.split('.')[0];
	        var plugins = $('[data-' + plugin + ']').not('[data-yeti-box="' + pluginId + '"]');
	
	        plugins.each(function () {
	          var _this = $(this);
	
	          _this.triggerHandler('close.zf.trigger', [_this]);
	        });
	      });
	    }
	  }
	
	  function resizeListener(debounce) {
	    var timer = void 0,
	        $nodes = $('[data-resize]');
	    if ($nodes.length) {
	      $(window).off('resize.zf.trigger').on('resize.zf.trigger', function (e) {
	        if (timer) {
	          clearTimeout(timer);
	        }
	
	        timer = setTimeout(function () {
	
	          if (!MutationObserver) {
	            //fallback for IE 9
	            $nodes.each(function () {
	              $(this).triggerHandler('resizeme.zf.trigger');
	            });
	          }
	          //trigger all listening elements and signal a resize event
	          $nodes.attr('data-events', "resize");
	        }, debounce || 10); //default time to emit resize event
	      });
	    }
	  }
	
	  function scrollListener(debounce) {
	    var timer = void 0,
	        $nodes = $('[data-scroll]');
	    if ($nodes.length) {
	      $(window).off('scroll.zf.trigger').on('scroll.zf.trigger', function (e) {
	        if (timer) {
	          clearTimeout(timer);
	        }
	
	        timer = setTimeout(function () {
	
	          if (!MutationObserver) {
	            //fallback for IE 9
	            $nodes.each(function () {
	              $(this).triggerHandler('scrollme.zf.trigger');
	            });
	          }
	          //trigger all listening elements and signal a scroll event
	          $nodes.attr('data-events', "scroll");
	        }, debounce || 10); //default time to emit scroll event
	      });
	    }
	  }
	
	  function mutateListener(debounce) {
	    var $nodes = $('[data-mutate]');
	    if ($nodes.length && MutationObserver) {
	      //trigger all listening elements and signal a mutate event
	      //no IE 9 or 10
	      $nodes.each(function () {
	        $(this).triggerHandler('mutateme.zf.trigger');
	      });
	    }
	  }
	
	  function eventsListener() {
	    if (!MutationObserver) {
	      return false;
	    }
	    var nodes = document.querySelectorAll('[data-resize], [data-scroll], [data-mutate]');
	
	    //element callback
	    var listeningElementsMutation = function listeningElementsMutation(mutationRecordsList) {
	      var $target = $(mutationRecordsList[0].target);
	
	      //trigger the event handler for the element depending on type
	      switch (mutationRecordsList[0].type) {
	
	        case "attributes":
	          if ($target.attr("data-events") === "scroll" && mutationRecordsList[0].attributeName === "data-events") {
	            $target.triggerHandler('scrollme.zf.trigger', [$target, window.pageYOffset]);
	          }
	          if ($target.attr("data-events") === "resize" && mutationRecordsList[0].attributeName === "data-events") {
	            $target.triggerHandler('resizeme.zf.trigger', [$target]);
	          }
	          if (mutationRecordsList[0].attributeName === "style") {
	            $target.closest("[data-mutate]").attr("data-events", "mutate");
	            $target.closest("[data-mutate]").triggerHandler('mutateme.zf.trigger', [$target.closest("[data-mutate]")]);
	          }
	          break;
	
	        case "childList":
	          $target.closest("[data-mutate]").attr("data-events", "mutate");
	          $target.closest("[data-mutate]").triggerHandler('mutateme.zf.trigger', [$target.closest("[data-mutate]")]);
	          break;
	
	        default:
	          return false;
	        //nothing
	      }
	    };
	
	    if (nodes.length) {
	      //for each element that needs to listen for resizing, scrolling, or mutation add a single observer
	      for (var i = 0; i <= nodes.length - 1; i++) {
	        var elementObserver = new MutationObserver(listeningElementsMutation);
	        elementObserver.observe(nodes[i], { attributes: true, childList: true, characterData: false, subtree: true, attributeFilter: ["data-events", "style"] });
	      }
	    }
	  }
	
	  // ------------------------------------
	
	  // [PH]
	  // Foundation.CheckWatchers = checkWatchers;
	  Foundation.IHearYou = checkListeners;
	  // Foundation.ISeeYou = scrollListener;
	  // Foundation.IFeelYou = closemeListener;
	}(jQuery);
	
	// function domMutationObserver(debounce) {
	//   // !!! This is coming soon and needs more work; not active  !!! //
	//   var timer,
	//   nodes = document.querySelectorAll('[data-mutate]');
	//   //
	//   if (nodes.length) {
	//     // var MutationObserver = (function () {
	//     //   var prefixes = ['WebKit', 'Moz', 'O', 'Ms', ''];
	//     //   for (var i=0; i < prefixes.length; i++) {
	//     //     if (prefixes[i] + 'MutationObserver' in window) {
	//     //       return window[prefixes[i] + 'MutationObserver'];
	//     //     }
	//     //   }
	//     //   return false;
	//     // }());
	//
	//
	//     //for the body, we need to listen for all changes effecting the style and class attributes
	//     var bodyObserver = new MutationObserver(bodyMutation);
	//     bodyObserver.observe(document.body, { attributes: true, childList: true, characterData: false, subtree:true, attributeFilter:["style", "class"]});
	//
	//
	//     //body callback
	//     function bodyMutation(mutate) {
	//       //trigger all listening elements and signal a mutation event
	//       if (timer) { clearTimeout(timer); }
	//
	//       timer = setTimeout(function() {
	//         bodyObserver.disconnect();
	//         $('[data-mutate]').attr('data-events',"mutate");
	//       }, debounce || 150);
	//     }
	//   }
	// }

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(161);
	
	__webpack_require__(163);
	
	__webpack_require__(164);
	
	__webpack_require__(165);
	
	__webpack_require__(166);
	
	__webpack_require__(167);
	
	__webpack_require__(168);
	
	__webpack_require__(169);
	
	__webpack_require__(162);

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// NOTE: in WP we use the WP intern jQuery version
	// globally "export" jquery for our plugins
	// import jQuery from 'jquery';
	
	// import version from './lib/version';
	
	__webpack_require__(185);
	
	__webpack_require__(170);
	
	__webpack_require__(174);
	
	var _oldBrowser = __webpack_require__(173);
	
	var _oldBrowser2 = _interopRequireDefault(_oldBrowser);
	
	var _scrollUp = __webpack_require__(160);
	
	var _scrollUp2 = _interopRequireDefault(_scrollUp);
	
	__webpack_require__(177);
	
	__webpack_require__(175);
	
	__webpack_require__(181);
	
	__webpack_require__(179);
	
	__webpack_require__(182);
	
	__webpack_require__(178);
	
	__webpack_require__(180);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// ////////////////////////////////////////////////////////////
	// init foundation
	jQuery(function ($) {
	    var $menuButton = $('.menu-toggle .hamburger'),
	        $offCanvasInner = $('.off-canvas-wrapper-inner'),
	        $primaryNav = $('.primary-nav');
	
	    $primaryNav.css('opacity', 1);
	
	    $(document).foundation().on('opened.zf.offcanvas', function () {
	        $menuButton.addClass('is-active');
	
	        $offCanvasInner.addClass('js-off-canvas-opened');
	        $offCanvasInner.removeClass('js-off-canvas-closed');
	    }).on('closed.zf.offcanvas', function () {
	        $menuButton.removeClass('is-active');
	
	        $offCanvasInner.addClass('js-off-canvas-closed');
	        $offCanvasInner.removeClass('js-off-canvas-opened');
	    });
	
	    // add a class to the html tag so animations and the like can react when the page is loaded
	    document.documentElement.classList.add('page-loaded');
	
	    // you can listen to breakpoint changes like so:
	    // $(window).on('changed.zf.mediaquery', (event, current, old) => {
	    //    console.log(`Breakpoint changed from "${old}" to "${current}"`);
	    // });
	});
	
	// ////////////////////////////////////////////////////////////
	// browser alerts
	
	
	// ////////////////////////////////////////////////////////////
	// track contact form 7 submissions
	
	(0, _oldBrowser2.default)();
	
	// ////////////////////////////////////////////////////////////
	// scroll events
	
	(0, _scrollUp2.default)();
	
	// ////////////////////////////////////////////////////////////
	// sliding header
	
	
	// ////////////////////////////////////////////////////////////
	// form helpers
	
	
	// ////////////////////////////////////////////////////////////
	// modal
	// import './lib/modal';
	
	// ////////////////////////////////////////////////////////////
	// masonry
	
	
	// ////////////////////////////////////////////////////////////
	// masonry
	
	
	// ////////////////////////////////////////////////////////////
	// swiper
	
	
	// ////////////////////////////////////////////////////////////
	// map
	
	
	// ////////////////////////////////////////////////////////////
	// map

/***/ }),
/* 172 */,
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$selector = _ref.selector,
	        selector = _ref$selector === undefined ? '.browser-alert--browsehappy' : _ref$selector,
	        _ref$closeSelector = _ref.closeSelector,
	        closeSelector = _ref$closeSelector === undefined ? '.js-close-browser-alert-info' : _ref$closeSelector,
	        _ref$cookieName = _ref.cookieName,
	        cookieName = _ref$cookieName === undefined ? 'oldBrowserInfo' : _ref$cookieName;
	
	    jQuery(function ($) {
	        var $element = $(selector),
	            oldBrowser = (0, _oldBrowserCheck2.default)({
	            ie: '11',
	            firefox: '40',
	            chrome: '40',
	            opera: '31',
	            safari: '8',
	            android: '4.4'
	        });
	
	        // stores a cookie for the current session of the browser
	        function storeCookie() {
	            _jsCookie2.default.set(cookieName, true);
	        }
	
	        // if the cookie doesn't exist yet, show the info
	        if (oldBrowser && _jsCookie2.default.get(cookieName) === undefined) {
	            $element.show();
	
	            // init the close click to fade out the element
	            $(closeSelector).click(function (event) {
	                event.preventDefault();
	                storeCookie();
	                $element.fadeOut();
	            });
	        }
	    });
	};
	
	var _jsCookie = __webpack_require__(79);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	var _oldBrowserCheck = __webpack_require__(158);
	
	var _oldBrowserCheck2 = _interopRequireDefault(_oldBrowserCheck);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 174 */
/***/ (function(module, exports) {

	'use strict';
	
	var sentPageview = false;
	
	jQuery(function ($) {
	    // send pageview when cf7 hook was fired
	    $(document).on('wpcf7mailsent', function () {
	        window.dataLayer.push({
	            event: 'virtualPageview',
	            virtualPageURL: location.pathname + 'success/',
	            virtualPageTitle: 'CF7 Success'
	        });
	        sentPageview = true;
	    });
	
	    // when the hook hasn't fired, check if the class indicating this event exists and fire pageview
	    if (!sentPageview && $('.wpcf7-mail-sent-ok').length) {
	        setTimeout(function () {
	            window.dataLayer.push({
	                event: 'virtualPageview',
	                virtualPageURL: location.pathname + 'success/',
	                virtualPageTitle: 'CF7 Success'
	            });
	            sentPageview = true;
	        }, 500);
	    }
	});

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// only load our form helpers if we have a form on the current page
	jQuery(function ($) {
	    if ($('form').length || window.patternlab) {
	        __webpack_require__.e/* nsure */(0/* min-size */, function () {
	            var loadingIndicator = void 0,
	                selectAll = void 0,
	                fileInput = void 0,
	                floatingLabel = void 0,
	                $viewportMeta = $('meta[name="viewport"]'),
	                viewportMetaContent = $viewportMeta.attr('content'),
	                zoomEnableTimeout = function zoomEnableTimeout() {};
	
	            // prevent mobile zoom in
	            $('input, select, textarea').bind('touchstart focus blur', function (event) {
	                if (event.type === 'blur') {
	                    zoomEnableTimeout = setTimeout(function () {
	                        $viewportMeta.attr('content', viewportMetaContent);
	                    }, 100);
	                } else {
	                    clearTimeout(zoomEnableTimeout);
	                    $viewportMeta.attr('content', viewportMetaContent + ',maximum-scale=1');
	                }
	            });
	
	            // automatically attach an loading indicator to submit buttons on form submit
	            loadingIndicator = __webpack_require__(155).default;
	            loadingIndicator();
	
	            // enable an (de)select all radiobutton and checkboxes possibility
	            selectAll = __webpack_require__(156).default;
	            selectAll();
	
	            // style advanced file inputs
	            fileInput = __webpack_require__(153).default;
	            fileInput({
	                multibleFilesLabel: ':anz Dateien ausgewählt'
	            });
	
	            // automatically attach an loading indicator to submit buttons on form submit
	            floatingLabel = __webpack_require__(154).default;
	            floatingLabel();
	
	            // include form validation via parsley (with German language)
	            __webpack_require__(176);
	        });
	    }
	});

/***/ }),
/* 176 */,
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(83);
	
	jQuery(function ($) {
	    __webpack_require__.e/* nsure */(0, function (require) {
	        __webpack_require__.e/* require */(0/* min-size */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(214), __webpack_require__(83)]; (function () {
	            var $headroom = $('.headroom'),
	                $headroomSpacing = $('.headroom-spacing');
	
	            $(window).on('resize', function () {
	                if ($headroom.is('.headroom--fixed')) {
	                    $headroom.css('margin-top', 0);
	                }
	
	                $headroomSpacing.css('padding-top', $headroom.outerHeight());
	            }).trigger('resize');
	
	            $headroom.headroom({
	                offset: $headroom.height(),
	                tolerance: 20, // mostly used for touch-pads/-screens
	                classes: {
	                    initial: 'headroom--headroom',
	                    pinned: 'headroom--fixed',
	                    unpinned: 'headroom--unfixed',
	                    top: 'headroom--top',
	                    notTop: 'headroom--not-top'
	                },
	                onTop: function onTop() {
	                    $headroom.removeClass('headroom--fixed').css('margin-top', 0);
	
	                    $headroom.data('headroom').offset = $headroom.height();
	
	                    $headroomSpacing.css('padding-top', $headroom.outerHeight());
	                },
	                onPin: function onPin() {
	                    $headroom.data('headroom').offset = 0;
	
	                    $headroomSpacing.css('padding-top', $headroom.outerHeight());
	                },
	                onUnpin: function onUnpin() {
	                    $headroom.css('margin-top', 0);
	                }
	            });
	        }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));});
	    });
	});

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _version = __webpack_require__(183);
	
	var _version2 = _interopRequireDefault(_version);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	jQuery(function ($) {
	    var initMap = function initMap() {
	        var $maps = $('.map');
	
	        if ($maps.length) {
	            __webpack_require__.e/* nsure */(0/* min-size */, function (require) {
	                __webpack_require__.e/* require */(0/* min-size */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(237)]; (function ($script) {
	                    // load google maps
	                    $script('https://maps.googleapis.com/maps/api/js?key=AIzaSyBH8KexzV8B-Y8o-Hr6_PbP5qQdZgeJJP8', function () {
	                        // loop over map container
	                        $maps.each(function (i, container) {
	                            var $container = $(container),
	                                map = new google.maps.Map($container.find('.map__iframe')[0]),
	                                markers = [],
	                                bounds = new google.maps.LatLngBounds();
	
	                            /* eslint-disable */
	                            map.set('styles', [{
	                                "featureType": "administrative",
	                                "elementType": "labels.text.fill",
	                                "stylers": [{
	                                    "color": "#444444"
	                                }]
	                            }, {
	                                "featureType": "landscape",
	                                "elementType": "all",
	                                "stylers": [{
	                                    "color": "#f2f2f2"
	                                }]
	                            }, {
	                                "featureType": "poi",
	                                "elementType": "all",
	                                "stylers": [{
	                                    "visibility": "off"
	                                }]
	                            }, {
	                                "featureType": "road",
	                                "elementType": "all",
	                                "stylers": [{
	                                    "saturation": -100
	                                }, {
	                                    "lightness": 45
	                                }]
	                            }, {
	                                "featureType": "road.highway",
	                                "elementType": "all",
	                                "stylers": [{
	                                    "visibility": "simplified"
	                                }]
	                            }, {
	                                "featureType": "road.arterial",
	                                "elementType": "labels.icon",
	                                "stylers": [{
	                                    "visibility": "off"
	                                }]
	                            }, {
	                                "featureType": "transit",
	                                "elementType": "all",
	                                "stylers": [{
	                                    "visibility": "off"
	                                }]
	                            }, {
	                                "featureType": "water",
	                                "elementType": "all",
	                                "stylers": [{
	                                    "color": "#79a1b8"
	                                }, {
	                                    "visibility": "on"
	                                }]
	                            }]);
	                            /* eslint-enable */
	
	                            // add placemarks to the map
	                            $container.find('.map__list__item div').each(function (i, item) {
	                                var $item = $(item),
	                                    alternativePinColor = $item.data('alternative-pin-color'),
	                                    pinFile = alternativePinColor ? 'assets/img/placemarks/marker_alternative.png' : 'assets/img/placemarks/marker.png',
	                                    position = new google.maps.LatLng($item.data('lat'), $item.data('lng'));
	
	                                markers.push(position);
	
	                                (0, _version2.default)(pinFile).then(function (pin) {
	                                    var marker = new google.maps.Marker({
	                                        map: map,
	                                        position: position,
	                                        title: $item.data('title'),
	                                        cursor: 'pointer',
	                                        icon: {
	                                            size: new google.maps.Size(256, 256),
	                                            scaledSize: new google.maps.Size(36, 36),
	                                            origin: new google.maps.Point(0, 0),
	                                            anchor: new google.maps.Point(24, 43),
	                                            url: pin
	                                        }
	                                    });
	
	                                    marker.addListener('click', function () {
	                                        $item.find('a')[0].click();
	                                    });
	                                });
	                            });
	
	                            // set the bounds based on the markers
	                            markers.forEach(function (position) {
	                                bounds.extend(position);
	                            });
	
	                            map.fitBounds(bounds);
	                        });
	                    });
	                }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));});
	            });
	        }
	    };
	
	    window.initMap = initMap;
	    initMap();
	});

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	jQuery(function ($) {
	    var $masonry = $('.masonry');
	
	    if ($masonry.length) {
	        __webpack_require__.e/* nsure */(0/* min-size */, function (require) {
	            __webpack_require__.e/* require */(0/* min-size */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(217), __webpack_require__(219), __webpack_require__(221)]; (function (imagesLoaded, jQueryBridget, Masonry) {
	                // init jQuery on imageloaded
	                imagesLoaded.makeJQueryPlugin($);
	
	                // make Masonry a jQuery plugin
	                jQueryBridget('masonry', Masonry, $);
	
	                // loop over all our masonry blocks and init them
	                $masonry.each(function (i, container) {
	                    var $container = $(container);
	
	                    $container.imagesLoaded(function () {
	                        $container.masonry({
	                            columnWidth: '.masonry__sizer',
	                            itemSelector: '.masonry__item',
	                            percentPosition: true
	                        });
	                    });
	                });
	            }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));});
	        });
	    }
	});

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	jQuery(function ($) {
	    var $previewer = $('.previewer');
	
	    if ($previewer.length) {
	        __webpack_require__.e/* nsure */(0/* min-size */, function (require) {
	            __webpack_require__.e/* require */(0/* min-size */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = []; (function () {
	                $previewer.each(function (i, container) {
	                    var $container = $(container);
	
	                    $container.find('.js-load-more').on('click', function () {
	                        var $button = $(this);
	
	                        $button.prop('disabled', true);
	                        $container.addClass('is-loading');
	                        setTimeout(function () {
	                            var id = $button.data('lazies');
	
	                            $button.remove();
	
	                            $('#' + id).children().remove().appendTo($container.find('.previewer__posts'));
	
	                            $container.removeClass('is-loading');
	                        }, 350);
	                    });
	                });
	            }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));});
	        });
	    }
	});

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	jQuery(function ($) {
	    'use strict';
	
	    var $showcases = $('.project-overview');
	
	    if ($showcases.length) {
	        __webpack_require__.e/* nsure */(0/* min-size */, function (require) {
	            __webpack_require__.e/* require */(0/* min-size */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(218), __webpack_require__(233), __webpack_require__(229)]; (function (inView, Salvattore, queryString) {
	                var animationDelayMultiplier = 0,
	                    resetCounter = void 0,
	                    $projectsCopy = $('.project-overview__item').clone(),
	                    projectsGrid = document.querySelector('#projects-container'),
	                    userInput = void 0;
	
	                Salvattore.registerGrid(projectsGrid);
	
	                // on filter input change
	                $('.projects__filter__item input').on('change', function () {
	                    var $el = $(this),
	                        $filter = $('.projects__filter__item input:checked');
	
	                    $el.closest('.projects__filter__item').toggleClass('is-active', $el.prop('checked'));
	
	                    // at least one filter is active
	                    if ($filter.length) {
	                        // empty current project list
	                        $('.projects-container').empty();
	
	                        // add filtered projects
	                        $('.projects__filter__item input:checked').map(function (i, input) {
	                            $('.projects-container').append($projectsCopy.filter('.filter--' + $(input).val()));
	                        });
	                    } else {
	                        // re add all projects
	                        $('.projects-container').empty();
	
	                        $projectsCopy.each(function (i, project) {
	                            $('.projects-container').append(project);
	                        });
	                    }
	
	                    if (userInput !== false && history && history.pushState) {
	                        var filters = $filter.toArray().map(function (el) {
	                            return el.getAttribute('id').substr(7);
	                        }),
	                            urlParams = queryString.parse(location.search);
	
	                        urlParams.filter = filters && filters.length ? filters : undefined; // undefined clears the value
	
	                        history.pushState(null, '', '?' + queryString.stringify(urlParams));
	                    }
	
	                    // show all projects and reinit salvatore
	                    $('.project-overview__item').addClass('is-visible');
	                    Salvattore.registerGrid(projectsGrid);
	                });
	
	                // scroll in our projects on scroll
	                // NOTE: only works when the trigger wasn't changed yet
	                setTimeout(function () {
	                    inView('.project-overview__item').on('enter', function (el) {
	                        if (!el.classList.contains('is-visible') && !el.classList.contains('is-fixed')) {
	                            setTimeout(function () {
	                                el.classList.add('is-visible');
	                            }, 150 * animationDelayMultiplier++);
	                            clearTimeout(resetCounter);
	                            resetCounter = setTimeout(function () {
	                                animationDelayMultiplier = 0;
	                            }, 200);
	                        }
	                    }).check();
	                }, 10);
	
	                $(window).on('popstate', function () {
	                    var urlParams = queryString.parse(location.search);
	
	                    if ('filter' in urlParams) {
	
	                        var filter = urlParams.filter;
	
	                        if (typeof filter === 'string') {
	                            filter = filter.replace(/(\[|])/g, '').split(',');
	                        }
	
	                        $('.projects__filter__item input').each(function (i, el) {
	                            var $el = $(el),
	                                oldVal = $el.prop('checked'),
	                                checked = filter.indexOf($el.attr('id').substr(7)) !== -1;
	
	                            $el.prop('checked', checked);
	
	                            if (checked || checked !== oldVal) {
	                                userInput = false;
	                                $el.trigger('change');
	                                userInput = true;
	                            }
	                        });
	                    }
	                }).trigger('popstate');
	            }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));});
	        });
	    }
	});

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	jQuery(function ($) {
	    var $swiper = $('.swiper-container');
	
	    if ($swiper.length) {
	        __webpack_require__.e/* nsure */(0/* min-size */, function (require) {
	            __webpack_require__.e/* require */(5, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(239)]; (function (Swiper) {
	                // loop over swiper instances and init them
	                $swiper.each(function (i, container) {
	                    var $container = $(container),
	                        centeredSlides = $container.data('centered-slides'),
	                        height = $container.data('height') || undefined,
	                        spaceBetween = $container.data('space-between'),
	                        slidesOffsetBefore = $container.data('slides-offset-before');
	
	                    new Swiper(container, {
	                        loop: true,
	                        autoHeight: height === 'auto',
	                        height: !isNaN(height) ? height : undefined,
	                        centeredSlides: centeredSlides !== true && centeredSlides !== false ? true : centeredSlides,
	                        slidesPerView: 'auto',
	                        autoplay: $container.data('autoplay') || false,
	                        spaceBetween: !spaceBetween && spaceBetween !== 0 ? 1 : spaceBetween,
	                        slidesOffsetBefore: !slidesOffsetBefore && slidesOffsetBefore !== 0 ? 1 : slidesOffsetBefore,
	
	                        nextButton: $container.parent().find('.swiper-button-next'),
	                        prevButton: $container.parent().find('.swiper-button-prev'),
	
	                        onSlideChangeEnd: function onSlideChangeEnd() {
	                            // force repaint after slide, some browser have render issues otherwise
	                            $container.each(function () {
	                                this.style.display = 'none';
	                                this.offsetHeight;
	                                this.style.display = 'block';
	                            });
	                        }
	                    });
	                });
	            }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));});
	        });
	    }
	});

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(210);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(190);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// load the manifest
	window.manifest = jQuery.getJSON('/assets/manifest.json');
	
	exports.default = function () {
	    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(filePath) {
	        var cdn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	        var manifest, host;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        _context.next = 2;
	                        return window.manifest;
	
	                    case 2:
	                        manifest = _context.sent;
	                        host = cdn ? CONFIG.cdn : '';
	
	                        if (!manifest[filePath]) {
	                            _context.next = 6;
	                            break;
	                        }
	
	                        return _context.abrupt('return', host + '/' + manifest[filePath]);
	
	                    case 6:
	                        return _context.abrupt('return', host + '/' + filePath);
	
	                    case 7:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, this);
	    }));
	
	    return function (_x2) {
	        return _ref.apply(this, arguments);
	    };
	}();

/***/ }),
/* 184 */,
/* 185 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var objectfit = function objectfit($el) {
	    if (!('object-fit' in document.body.style)) {
	        jQuery(function ($) {
	            var $objectFitContainer = void 0;
	
	            if (!$el || !$el.length) {
	                $objectFitContainer = $('.object-fit');
	            } else {
	                $objectFitContainer = $el.find('.object-fit');
	            }
	
	            $objectFitContainer.each(function () {
	                var $container = $(this),
	                    imgUrl = $container.find('img').prop('src'),
	                    objectfitFallbackUrl = $container.find('img').data('objectfit');
	
	                if (objectfitFallbackUrl) {
	                    imgUrl = objectfitFallbackUrl;
	                }
	
	                if (imgUrl) {
	                    $container.css('backgroundImage', 'url(' + imgUrl + ')').addClass('compat-object-fit');
	                }
	            });
	        });
	    }
	};
	
	objectfit();
	
	exports.default = objectfit;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(193), __esModule: true };

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(194), __esModule: true };

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(195), __esModule: true };

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(196), __esModule: true };

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _promise = __webpack_require__(40);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (fn) {
	  return function () {
	    var gen = fn.apply(this, arguments);
	    return new _promise2.default(function (resolve, reject) {
	      function step(key, arg) {
	        try {
	          var info = gen[key](arg);
	          var value = info.value;
	        } catch (error) {
	          reject(error);
	          return;
	        }
	
	        if (info.done) {
	          resolve(value);
	        } else {
	          return _promise2.default.resolve(value).then(function (value) {
	            step("next", value);
	          }, function (err) {
	            step("throw", err);
	          });
	        }
	      }
	
	      return step("next");
	    });
	  };
	};

/***/ }),
/* 191 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(186);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(203);
	var $Object = __webpack_require__(3).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(204);
	module.exports = __webpack_require__(3).Object.keys;


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(205);
	__webpack_require__(45);
	__webpack_require__(206);
	__webpack_require__(207);
	module.exports = __webpack_require__(3).Symbol;


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(46);
	__webpack_require__(47);
	module.exports = __webpack_require__(71).f('iterator');


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(28);
	var gOPS = __webpack_require__(82);
	var pIE = __webpack_require__(64);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(12);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(26)('meta');
	var isObject = __webpack_require__(7);
	var has = __webpack_require__(10);
	var setDesc = __webpack_require__(8).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(18)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(64);
	var createDesc = __webpack_require__(23);
	var toIObject = __webpack_require__(13);
	var toPrimitive = __webpack_require__(39);
	var has = __webpack_require__(10);
	var IE8_DOM_DEFINE = __webpack_require__(41);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(5) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(13);
	var gOPN = __webpack_require__(81).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(9);
	var core = __webpack_require__(3);
	var fails = __webpack_require__(18);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(9);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(5), 'Object', { defineProperty: __webpack_require__(8).f });


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(38);
	var $keys = __webpack_require__(28);
	
	__webpack_require__(202)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(1);
	var has = __webpack_require__(10);
	var DESCRIPTORS = __webpack_require__(5);
	var $export = __webpack_require__(9);
	var redefine = __webpack_require__(44);
	var META = __webpack_require__(199).KEY;
	var $fails = __webpack_require__(18);
	var shared = __webpack_require__(29);
	var setToStringTag = __webpack_require__(19);
	var uid = __webpack_require__(26);
	var wks = __webpack_require__(2);
	var wksExt = __webpack_require__(71);
	var wksDefine = __webpack_require__(70);
	var enumKeys = __webpack_require__(197);
	var isArray = __webpack_require__(198);
	var anObject = __webpack_require__(4);
	var isObject = __webpack_require__(7);
	var toObject = __webpack_require__(38);
	var toIObject = __webpack_require__(13);
	var toPrimitive = __webpack_require__(39);
	var createDesc = __webpack_require__(23);
	var _create = __webpack_require__(42);
	var gOPNExt = __webpack_require__(201);
	var $GOPD = __webpack_require__(200);
	var $GOPS = __webpack_require__(82);
	var $DP = __webpack_require__(8);
	var $keys = __webpack_require__(28);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(81).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(64).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(16)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(6)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(70)('asyncIterator');


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(70)('observable');


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g = (function() { return this })() || Function("return this")();
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(209);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}


/***/ }),
/* 209 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // In sloppy mode, unbound `this` refers to the global object, fallback to
	  // Function constructor if we're in global strict mode. That is sadly a form
	  // of indirect eval which violates Content Security Policy.
	  (function() { return this })() || Function("return this")()
	);


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(208);


/***/ }),
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	// THIS FILE IS GENERATED - DO NOT EDIT!
	/*!mobile-detect v1.3.7 2017-09-06*/
	/*global module:false, define:false*/
	/*jshint latedef:false*/
	/*!@license Copyright 2013, Heinrich Goebl, License: MIT, see https://github.com/hgoebl/mobile-detect.js*/
	(function (define, undefined) {
	define(function () {
	    'use strict';
	
	    var impl = {};
	
	    impl.mobileDetectRules = {
	    "phones": {
	        "iPhone": "\\biPhone\\b|\\biPod\\b",
	        "BlackBerry": "BlackBerry|\\bBB10\\b|rim[0-9]+",
	        "HTC": "HTC|HTC.*(Sensation|Evo|Vision|Explorer|6800|8100|8900|A7272|S510e|C110e|Legend|Desire|T8282)|APX515CKT|Qtek9090|APA9292KT|HD_mini|Sensation.*Z710e|PG86100|Z715e|Desire.*(A8181|HD)|ADR6200|ADR6400L|ADR6425|001HT|Inspire 4G|Android.*\\bEVO\\b|T-Mobile G1|Z520m",
	        "Nexus": "Nexus One|Nexus S|Galaxy.*Nexus|Android.*Nexus.*Mobile|Nexus 4|Nexus 5|Nexus 6",
	        "Dell": "Dell.*Streak|Dell.*Aero|Dell.*Venue|DELL.*Venue Pro|Dell Flash|Dell Smoke|Dell Mini 3iX|XCD28|XCD35|\\b001DL\\b|\\b101DL\\b|\\bGS01\\b",
	        "Motorola": "Motorola|DROIDX|DROID BIONIC|\\bDroid\\b.*Build|Android.*Xoom|HRI39|MOT-|A1260|A1680|A555|A853|A855|A953|A955|A956|Motorola.*ELECTRIFY|Motorola.*i1|i867|i940|MB200|MB300|MB501|MB502|MB508|MB511|MB520|MB525|MB526|MB611|MB612|MB632|MB810|MB855|MB860|MB861|MB865|MB870|ME501|ME502|ME511|ME525|ME600|ME632|ME722|ME811|ME860|ME863|ME865|MT620|MT710|MT716|MT720|MT810|MT870|MT917|Motorola.*TITANIUM|WX435|WX445|XT300|XT301|XT311|XT316|XT317|XT319|XT320|XT390|XT502|XT530|XT531|XT532|XT535|XT603|XT610|XT611|XT615|XT681|XT701|XT702|XT711|XT720|XT800|XT806|XT860|XT862|XT875|XT882|XT883|XT894|XT901|XT907|XT909|XT910|XT912|XT928|XT926|XT915|XT919|XT925|XT1021|\\bMoto E\\b",
	        "Samsung": "\\bSamsung\\b|SM-G9250|GT-19300|SGH-I337|BGT-S5230|GT-B2100|GT-B2700|GT-B2710|GT-B3210|GT-B3310|GT-B3410|GT-B3730|GT-B3740|GT-B5510|GT-B5512|GT-B5722|GT-B6520|GT-B7300|GT-B7320|GT-B7330|GT-B7350|GT-B7510|GT-B7722|GT-B7800|GT-C3010|GT-C3011|GT-C3060|GT-C3200|GT-C3212|GT-C3212I|GT-C3262|GT-C3222|GT-C3300|GT-C3300K|GT-C3303|GT-C3303K|GT-C3310|GT-C3322|GT-C3330|GT-C3350|GT-C3500|GT-C3510|GT-C3530|GT-C3630|GT-C3780|GT-C5010|GT-C5212|GT-C6620|GT-C6625|GT-C6712|GT-E1050|GT-E1070|GT-E1075|GT-E1080|GT-E1081|GT-E1085|GT-E1087|GT-E1100|GT-E1107|GT-E1110|GT-E1120|GT-E1125|GT-E1130|GT-E1160|GT-E1170|GT-E1175|GT-E1180|GT-E1182|GT-E1200|GT-E1210|GT-E1225|GT-E1230|GT-E1390|GT-E2100|GT-E2120|GT-E2121|GT-E2152|GT-E2220|GT-E2222|GT-E2230|GT-E2232|GT-E2250|GT-E2370|GT-E2550|GT-E2652|GT-E3210|GT-E3213|GT-I5500|GT-I5503|GT-I5700|GT-I5800|GT-I5801|GT-I6410|GT-I6420|GT-I7110|GT-I7410|GT-I7500|GT-I8000|GT-I8150|GT-I8160|GT-I8190|GT-I8320|GT-I8330|GT-I8350|GT-I8530|GT-I8700|GT-I8703|GT-I8910|GT-I9000|GT-I9001|GT-I9003|GT-I9010|GT-I9020|GT-I9023|GT-I9070|GT-I9082|GT-I9100|GT-I9103|GT-I9220|GT-I9250|GT-I9300|GT-I9305|GT-I9500|GT-I9505|GT-M3510|GT-M5650|GT-M7500|GT-M7600|GT-M7603|GT-M8800|GT-M8910|GT-N7000|GT-S3110|GT-S3310|GT-S3350|GT-S3353|GT-S3370|GT-S3650|GT-S3653|GT-S3770|GT-S3850|GT-S5210|GT-S5220|GT-S5229|GT-S5230|GT-S5233|GT-S5250|GT-S5253|GT-S5260|GT-S5263|GT-S5270|GT-S5300|GT-S5330|GT-S5350|GT-S5360|GT-S5363|GT-S5369|GT-S5380|GT-S5380D|GT-S5560|GT-S5570|GT-S5600|GT-S5603|GT-S5610|GT-S5620|GT-S5660|GT-S5670|GT-S5690|GT-S5750|GT-S5780|GT-S5830|GT-S5839|GT-S6102|GT-S6500|GT-S7070|GT-S7200|GT-S7220|GT-S7230|GT-S7233|GT-S7250|GT-S7500|GT-S7530|GT-S7550|GT-S7562|GT-S7710|GT-S8000|GT-S8003|GT-S8500|GT-S8530|GT-S8600|SCH-A310|SCH-A530|SCH-A570|SCH-A610|SCH-A630|SCH-A650|SCH-A790|SCH-A795|SCH-A850|SCH-A870|SCH-A890|SCH-A930|SCH-A950|SCH-A970|SCH-A990|SCH-I100|SCH-I110|SCH-I400|SCH-I405|SCH-I500|SCH-I510|SCH-I515|SCH-I600|SCH-I730|SCH-I760|SCH-I770|SCH-I830|SCH-I910|SCH-I920|SCH-I959|SCH-LC11|SCH-N150|SCH-N300|SCH-R100|SCH-R300|SCH-R351|SCH-R400|SCH-R410|SCH-T300|SCH-U310|SCH-U320|SCH-U350|SCH-U360|SCH-U365|SCH-U370|SCH-U380|SCH-U410|SCH-U430|SCH-U450|SCH-U460|SCH-U470|SCH-U490|SCH-U540|SCH-U550|SCH-U620|SCH-U640|SCH-U650|SCH-U660|SCH-U700|SCH-U740|SCH-U750|SCH-U810|SCH-U820|SCH-U900|SCH-U940|SCH-U960|SCS-26UC|SGH-A107|SGH-A117|SGH-A127|SGH-A137|SGH-A157|SGH-A167|SGH-A177|SGH-A187|SGH-A197|SGH-A227|SGH-A237|SGH-A257|SGH-A437|SGH-A517|SGH-A597|SGH-A637|SGH-A657|SGH-A667|SGH-A687|SGH-A697|SGH-A707|SGH-A717|SGH-A727|SGH-A737|SGH-A747|SGH-A767|SGH-A777|SGH-A797|SGH-A817|SGH-A827|SGH-A837|SGH-A847|SGH-A867|SGH-A877|SGH-A887|SGH-A897|SGH-A927|SGH-B100|SGH-B130|SGH-B200|SGH-B220|SGH-C100|SGH-C110|SGH-C120|SGH-C130|SGH-C140|SGH-C160|SGH-C170|SGH-C180|SGH-C200|SGH-C207|SGH-C210|SGH-C225|SGH-C230|SGH-C417|SGH-C450|SGH-D307|SGH-D347|SGH-D357|SGH-D407|SGH-D415|SGH-D780|SGH-D807|SGH-D980|SGH-E105|SGH-E200|SGH-E315|SGH-E316|SGH-E317|SGH-E335|SGH-E590|SGH-E635|SGH-E715|SGH-E890|SGH-F300|SGH-F480|SGH-I200|SGH-I300|SGH-I320|SGH-I550|SGH-I577|SGH-I600|SGH-I607|SGH-I617|SGH-I627|SGH-I637|SGH-I677|SGH-I700|SGH-I717|SGH-I727|SGH-i747M|SGH-I777|SGH-I780|SGH-I827|SGH-I847|SGH-I857|SGH-I896|SGH-I897|SGH-I900|SGH-I907|SGH-I917|SGH-I927|SGH-I937|SGH-I997|SGH-J150|SGH-J200|SGH-L170|SGH-L700|SGH-M110|SGH-M150|SGH-M200|SGH-N105|SGH-N500|SGH-N600|SGH-N620|SGH-N625|SGH-N700|SGH-N710|SGH-P107|SGH-P207|SGH-P300|SGH-P310|SGH-P520|SGH-P735|SGH-P777|SGH-Q105|SGH-R210|SGH-R220|SGH-R225|SGH-S105|SGH-S307|SGH-T109|SGH-T119|SGH-T139|SGH-T209|SGH-T219|SGH-T229|SGH-T239|SGH-T249|SGH-T259|SGH-T309|SGH-T319|SGH-T329|SGH-T339|SGH-T349|SGH-T359|SGH-T369|SGH-T379|SGH-T409|SGH-T429|SGH-T439|SGH-T459|SGH-T469|SGH-T479|SGH-T499|SGH-T509|SGH-T519|SGH-T539|SGH-T559|SGH-T589|SGH-T609|SGH-T619|SGH-T629|SGH-T639|SGH-T659|SGH-T669|SGH-T679|SGH-T709|SGH-T719|SGH-T729|SGH-T739|SGH-T746|SGH-T749|SGH-T759|SGH-T769|SGH-T809|SGH-T819|SGH-T839|SGH-T919|SGH-T929|SGH-T939|SGH-T959|SGH-T989|SGH-U100|SGH-U200|SGH-U800|SGH-V205|SGH-V206|SGH-X100|SGH-X105|SGH-X120|SGH-X140|SGH-X426|SGH-X427|SGH-X475|SGH-X495|SGH-X497|SGH-X507|SGH-X600|SGH-X610|SGH-X620|SGH-X630|SGH-X700|SGH-X820|SGH-X890|SGH-Z130|SGH-Z150|SGH-Z170|SGH-ZX10|SGH-ZX20|SHW-M110|SPH-A120|SPH-A400|SPH-A420|SPH-A460|SPH-A500|SPH-A560|SPH-A600|SPH-A620|SPH-A660|SPH-A700|SPH-A740|SPH-A760|SPH-A790|SPH-A800|SPH-A820|SPH-A840|SPH-A880|SPH-A900|SPH-A940|SPH-A960|SPH-D600|SPH-D700|SPH-D710|SPH-D720|SPH-I300|SPH-I325|SPH-I330|SPH-I350|SPH-I500|SPH-I600|SPH-I700|SPH-L700|SPH-M100|SPH-M220|SPH-M240|SPH-M300|SPH-M305|SPH-M320|SPH-M330|SPH-M350|SPH-M360|SPH-M370|SPH-M380|SPH-M510|SPH-M540|SPH-M550|SPH-M560|SPH-M570|SPH-M580|SPH-M610|SPH-M620|SPH-M630|SPH-M800|SPH-M810|SPH-M850|SPH-M900|SPH-M910|SPH-M920|SPH-M930|SPH-N100|SPH-N200|SPH-N240|SPH-N300|SPH-N400|SPH-Z400|SWC-E100|SCH-i909|GT-N7100|GT-N7105|SCH-I535|SM-N900A|SGH-I317|SGH-T999L|GT-S5360B|GT-I8262|GT-S6802|GT-S6312|GT-S6310|GT-S5312|GT-S5310|GT-I9105|GT-I8510|GT-S6790N|SM-G7105|SM-N9005|GT-S5301|GT-I9295|GT-I9195|SM-C101|GT-S7392|GT-S7560|GT-B7610|GT-I5510|GT-S7582|GT-S7530E|GT-I8750|SM-G9006V|SM-G9008V|SM-G9009D|SM-G900A|SM-G900D|SM-G900F|SM-G900H|SM-G900I|SM-G900J|SM-G900K|SM-G900L|SM-G900M|SM-G900P|SM-G900R4|SM-G900S|SM-G900T|SM-G900V|SM-G900W8|SHV-E160K|SCH-P709|SCH-P729|SM-T2558|GT-I9205|SM-G9350|SM-J120F|SM-G920F|SM-G920V|SM-G930F|SM-N910C",
	        "LG": "\\bLG\\b;|LG[- ]?(C800|C900|E400|E610|E900|E-900|F160|F180K|F180L|F180S|730|855|L160|LS740|LS840|LS970|LU6200|MS690|MS695|MS770|MS840|MS870|MS910|P500|P700|P705|VM696|AS680|AS695|AX840|C729|E970|GS505|272|C395|E739BK|E960|L55C|L75C|LS696|LS860|P769BK|P350|P500|P509|P870|UN272|US730|VS840|VS950|LN272|LN510|LS670|LS855|LW690|MN270|MN510|P509|P769|P930|UN200|UN270|UN510|UN610|US670|US740|US760|UX265|UX840|VN271|VN530|VS660|VS700|VS740|VS750|VS910|VS920|VS930|VX9200|VX11000|AX840A|LW770|P506|P925|P999|E612|D955|D802|MS323)",
	        "Sony": "SonyST|SonyLT|SonyEricsson|SonyEricssonLT15iv|LT18i|E10i|LT28h|LT26w|SonyEricssonMT27i|C5303|C6902|C6903|C6906|C6943|D2533",
	        "Asus": "Asus.*Galaxy|PadFone.*Mobile",
	        "NokiaLumia": "Lumia [0-9]{3,4}",
	        "Micromax": "Micromax.*\\b(A210|A92|A88|A72|A111|A110Q|A115|A116|A110|A90S|A26|A51|A35|A54|A25|A27|A89|A68|A65|A57|A90)\\b",
	        "Palm": "PalmSource|Palm",
	        "Vertu": "Vertu|Vertu.*Ltd|Vertu.*Ascent|Vertu.*Ayxta|Vertu.*Constellation(F|Quest)?|Vertu.*Monika|Vertu.*Signature",
	        "Pantech": "PANTECH|IM-A850S|IM-A840S|IM-A830L|IM-A830K|IM-A830S|IM-A820L|IM-A810K|IM-A810S|IM-A800S|IM-T100K|IM-A725L|IM-A780L|IM-A775C|IM-A770K|IM-A760S|IM-A750K|IM-A740S|IM-A730S|IM-A720L|IM-A710K|IM-A690L|IM-A690S|IM-A650S|IM-A630K|IM-A600S|VEGA PTL21|PT003|P8010|ADR910L|P6030|P6020|P9070|P4100|P9060|P5000|CDM8992|TXT8045|ADR8995|IS11PT|P2030|P6010|P8000|PT002|IS06|CDM8999|P9050|PT001|TXT8040|P2020|P9020|P2000|P7040|P7000|C790",
	        "Fly": "IQ230|IQ444|IQ450|IQ440|IQ442|IQ441|IQ245|IQ256|IQ236|IQ255|IQ235|IQ245|IQ275|IQ240|IQ285|IQ280|IQ270|IQ260|IQ250",
	        "Wiko": "KITE 4G|HIGHWAY|GETAWAY|STAIRWAY|DARKSIDE|DARKFULL|DARKNIGHT|DARKMOON|SLIDE|WAX 4G|RAINBOW|BLOOM|SUNSET|GOA(?!nna)|LENNY|BARRY|IGGY|OZZY|CINK FIVE|CINK PEAX|CINK PEAX 2|CINK SLIM|CINK SLIM 2|CINK +|CINK KING|CINK PEAX|CINK SLIM|SUBLIM",
	        "iMobile": "i-mobile (IQ|i-STYLE|idea|ZAA|Hitz)",
	        "SimValley": "\\b(SP-80|XT-930|SX-340|XT-930|SX-310|SP-360|SP60|SPT-800|SP-120|SPT-800|SP-140|SPX-5|SPX-8|SP-100|SPX-8|SPX-12)\\b",
	        "Wolfgang": "AT-B24D|AT-AS50HD|AT-AS40W|AT-AS55HD|AT-AS45q2|AT-B26D|AT-AS50Q",
	        "Alcatel": "Alcatel",
	        "Nintendo": "Nintendo 3DS",
	        "Amoi": "Amoi",
	        "INQ": "INQ",
	        "GenericPhone": "Tapatalk|PDA;|SAGEM|\\bmmp\\b|pocket|\\bpsp\\b|symbian|Smartphone|smartfon|treo|up.browser|up.link|vodafone|\\bwap\\b|nokia|Series40|Series60|S60|SonyEricsson|N900|MAUI.*WAP.*Browser"
	    },
	    "tablets": {
	        "iPad": "iPad|iPad.*Mobile",
	        "NexusTablet": "Android.*Nexus[\\s]+(7|9|10)",
	        "SamsungTablet": "SAMSUNG.*Tablet|Galaxy.*Tab|SC-01C|GT-P1000|GT-P1003|GT-P1010|GT-P3105|GT-P6210|GT-P6800|GT-P6810|GT-P7100|GT-P7300|GT-P7310|GT-P7500|GT-P7510|SCH-I800|SCH-I815|SCH-I905|SGH-I957|SGH-I987|SGH-T849|SGH-T859|SGH-T869|SPH-P100|GT-P3100|GT-P3108|GT-P3110|GT-P5100|GT-P5110|GT-P6200|GT-P7320|GT-P7511|GT-N8000|GT-P8510|SGH-I497|SPH-P500|SGH-T779|SCH-I705|SCH-I915|GT-N8013|GT-P3113|GT-P5113|GT-P8110|GT-N8010|GT-N8005|GT-N8020|GT-P1013|GT-P6201|GT-P7501|GT-N5100|GT-N5105|GT-N5110|SHV-E140K|SHV-E140L|SHV-E140S|SHV-E150S|SHV-E230K|SHV-E230L|SHV-E230S|SHW-M180K|SHW-M180L|SHW-M180S|SHW-M180W|SHW-M300W|SHW-M305W|SHW-M380K|SHW-M380S|SHW-M380W|SHW-M430W|SHW-M480K|SHW-M480S|SHW-M480W|SHW-M485W|SHW-M486W|SHW-M500W|GT-I9228|SCH-P739|SCH-I925|GT-I9200|GT-P5200|GT-P5210|GT-P5210X|SM-T311|SM-T310|SM-T310X|SM-T210|SM-T210R|SM-T211|SM-P600|SM-P601|SM-P605|SM-P900|SM-P901|SM-T217|SM-T217A|SM-T217S|SM-P6000|SM-T3100|SGH-I467|XE500|SM-T110|GT-P5220|GT-I9200X|GT-N5110X|GT-N5120|SM-P905|SM-T111|SM-T2105|SM-T315|SM-T320|SM-T320X|SM-T321|SM-T520|SM-T525|SM-T530NU|SM-T230NU|SM-T330NU|SM-T900|XE500T1C|SM-P605V|SM-P905V|SM-T337V|SM-T537V|SM-T707V|SM-T807V|SM-P600X|SM-P900X|SM-T210X|SM-T230|SM-T230X|SM-T325|GT-P7503|SM-T531|SM-T330|SM-T530|SM-T705|SM-T705C|SM-T535|SM-T331|SM-T800|SM-T700|SM-T537|SM-T807|SM-P907A|SM-T337A|SM-T537A|SM-T707A|SM-T807A|SM-T237|SM-T807P|SM-P607T|SM-T217T|SM-T337T|SM-T807T|SM-T116NQ|SM-T116BU|SM-P550|SM-T350|SM-T550|SM-T9000|SM-P9000|SM-T705Y|SM-T805|GT-P3113|SM-T710|SM-T810|SM-T815|SM-T360|SM-T533|SM-T113|SM-T335|SM-T715|SM-T560|SM-T670|SM-T677|SM-T377|SM-T567|SM-T357T|SM-T555|SM-T561|SM-T713|SM-T719|SM-T813|SM-T819|SM-T580|SM-T355Y|SM-T280|SM-T817A|SM-T820|SM-W700|SM-P580|SM-T587|SM-P350|SM-P555M|SM-P355M|SM-T113NU|SM-T815Y",
	        "Kindle": "Kindle|Silk.*Accelerated|Android.*\\b(KFOT|KFTT|KFJWI|KFJWA|KFOTE|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|WFJWAE|KFSAWA|KFSAWI|KFASWI|KFARWI|KFFOWI|KFGIWI|KFMEWI)\\b|Android.*Silk\/[0-9.]+ like Chrome\/[0-9.]+ (?!Mobile)",
	        "SurfaceTablet": "Windows NT [0-9.]+; ARM;.*(Tablet|ARMBJS)",
	        "HPTablet": "HP Slate (7|8|10)|HP ElitePad 900|hp-tablet|EliteBook.*Touch|HP 8|Slate 21|HP SlateBook 10",
	        "AsusTablet": "^.*PadFone((?!Mobile).)*$|Transformer|TF101|TF101G|TF300T|TF300TG|TF300TL|TF700T|TF700KL|TF701T|TF810C|ME171|ME301T|ME302C|ME371MG|ME370T|ME372MG|ME172V|ME173X|ME400C|Slider SL101|\\bK00F\\b|\\bK00C\\b|\\bK00E\\b|\\bK00L\\b|TX201LA|ME176C|ME102A|\\bM80TA\\b|ME372CL|ME560CG|ME372CG|ME302KL| K010 | K011 | K017 | K01E |ME572C|ME103K|ME170C|ME171C|\\bME70C\\b|ME581C|ME581CL|ME8510C|ME181C|P01Y|PO1MA|P01Z|\\bP027\\b",
	        "BlackBerryTablet": "PlayBook|RIM Tablet",
	        "HTCtablet": "HTC_Flyer_P512|HTC Flyer|HTC Jetstream|HTC-P715a|HTC EVO View 4G|PG41200|PG09410",
	        "MotorolaTablet": "xoom|sholest|MZ615|MZ605|MZ505|MZ601|MZ602|MZ603|MZ604|MZ606|MZ607|MZ608|MZ609|MZ615|MZ616|MZ617",
	        "NookTablet": "Android.*Nook|NookColor|nook browser|BNRV200|BNRV200A|BNTV250|BNTV250A|BNTV400|BNTV600|LogicPD Zoom2",
	        "AcerTablet": "Android.*; \\b(A100|A101|A110|A200|A210|A211|A500|A501|A510|A511|A700|A701|W500|W500P|W501|W501P|W510|W511|W700|G100|G100W|B1-A71|B1-710|B1-711|A1-810|A1-811|A1-830)\\b|W3-810|\\bA3-A10\\b|\\bA3-A11\\b|\\bA3-A20\\b|\\bA3-A30",
	        "ToshibaTablet": "Android.*(AT100|AT105|AT200|AT205|AT270|AT275|AT300|AT305|AT1S5|AT500|AT570|AT700|AT830)|TOSHIBA.*FOLIO",
	        "LGTablet": "\\bL-06C|LG-V909|LG-V900|LG-V700|LG-V510|LG-V500|LG-V410|LG-V400|LG-VK810\\b",
	        "FujitsuTablet": "Android.*\\b(F-01D|F-02F|F-05E|F-10D|M532|Q572)\\b",
	        "PrestigioTablet": "PMP3170B|PMP3270B|PMP3470B|PMP7170B|PMP3370B|PMP3570C|PMP5870C|PMP3670B|PMP5570C|PMP5770D|PMP3970B|PMP3870C|PMP5580C|PMP5880D|PMP5780D|PMP5588C|PMP7280C|PMP7280C3G|PMP7280|PMP7880D|PMP5597D|PMP5597|PMP7100D|PER3464|PER3274|PER3574|PER3884|PER5274|PER5474|PMP5097CPRO|PMP5097|PMP7380D|PMP5297C|PMP5297C_QUAD|PMP812E|PMP812E3G|PMP812F|PMP810E|PMP880TD|PMT3017|PMT3037|PMT3047|PMT3057|PMT7008|PMT5887|PMT5001|PMT5002",
	        "LenovoTablet": "Lenovo TAB|Idea(Tab|Pad)( A1|A10| K1|)|ThinkPad([ ]+)?Tablet|YT3-850M|YT3-X90L|YT3-X90F|YT3-X90X|Lenovo.*(S2109|S2110|S5000|S6000|K3011|A3000|A3500|A1000|A2107|A2109|A1107|A5500|A7600|B6000|B8000|B8080)(-|)(FL|F|HV|H|)",
	        "DellTablet": "Venue 11|Venue 8|Venue 7|Dell Streak 10|Dell Streak 7",
	        "YarvikTablet": "Android.*\\b(TAB210|TAB211|TAB224|TAB250|TAB260|TAB264|TAB310|TAB360|TAB364|TAB410|TAB411|TAB420|TAB424|TAB450|TAB460|TAB461|TAB464|TAB465|TAB467|TAB468|TAB07-100|TAB07-101|TAB07-150|TAB07-151|TAB07-152|TAB07-200|TAB07-201-3G|TAB07-210|TAB07-211|TAB07-212|TAB07-214|TAB07-220|TAB07-400|TAB07-485|TAB08-150|TAB08-200|TAB08-201-3G|TAB08-201-30|TAB09-100|TAB09-211|TAB09-410|TAB10-150|TAB10-201|TAB10-211|TAB10-400|TAB10-410|TAB13-201|TAB274EUK|TAB275EUK|TAB374EUK|TAB462EUK|TAB474EUK|TAB9-200)\\b",
	        "MedionTablet": "Android.*\\bOYO\\b|LIFE.*(P9212|P9514|P9516|S9512)|LIFETAB",
	        "ArnovaTablet": "97G4|AN10G2|AN7bG3|AN7fG3|AN8G3|AN8cG3|AN7G3|AN9G3|AN7dG3|AN7dG3ST|AN7dG3ChildPad|AN10bG3|AN10bG3DT|AN9G2",
	        "IntensoTablet": "INM8002KP|INM1010FP|INM805ND|Intenso Tab|TAB1004",
	        "IRUTablet": "M702pro",
	        "MegafonTablet": "MegaFon V9|\\bZTE V9\\b|Android.*\\bMT7A\\b",
	        "EbodaTablet": "E-Boda (Supreme|Impresspeed|Izzycomm|Essential)",
	        "AllViewTablet": "Allview.*(Viva|Alldro|City|Speed|All TV|Frenzy|Quasar|Shine|TX1|AX1|AX2)",
	        "ArchosTablet": "\\b(101G9|80G9|A101IT)\\b|Qilive 97R|Archos5|\\bARCHOS (70|79|80|90|97|101|FAMILYPAD|)(b|c|)(G10| Cobalt| TITANIUM(HD|)| Xenon| Neon|XSK| 2| XS 2| PLATINUM| CARBON|GAMEPAD)\\b",
	        "AinolTablet": "NOVO7|NOVO8|NOVO10|Novo7Aurora|Novo7Basic|NOVO7PALADIN|novo9-Spark",
	        "NokiaLumiaTablet": "Lumia 2520",
	        "SonyTablet": "Sony.*Tablet|Xperia Tablet|Sony Tablet S|SO-03E|SGPT12|SGPT13|SGPT114|SGPT121|SGPT122|SGPT123|SGPT111|SGPT112|SGPT113|SGPT131|SGPT132|SGPT133|SGPT211|SGPT212|SGPT213|SGP311|SGP312|SGP321|EBRD1101|EBRD1102|EBRD1201|SGP351|SGP341|SGP511|SGP512|SGP521|SGP541|SGP551|SGP621|SGP612|SOT31",
	        "PhilipsTablet": "\\b(PI2010|PI3000|PI3100|PI3105|PI3110|PI3205|PI3210|PI3900|PI4010|PI7000|PI7100)\\b",
	        "CubeTablet": "Android.*(K8GT|U9GT|U10GT|U16GT|U17GT|U18GT|U19GT|U20GT|U23GT|U30GT)|CUBE U8GT",
	        "CobyTablet": "MID1042|MID1045|MID1125|MID1126|MID7012|MID7014|MID7015|MID7034|MID7035|MID7036|MID7042|MID7048|MID7127|MID8042|MID8048|MID8127|MID9042|MID9740|MID9742|MID7022|MID7010",
	        "MIDTablet": "M9701|M9000|M9100|M806|M1052|M806|T703|MID701|MID713|MID710|MID727|MID760|MID830|MID728|MID933|MID125|MID810|MID732|MID120|MID930|MID800|MID731|MID900|MID100|MID820|MID735|MID980|MID130|MID833|MID737|MID960|MID135|MID860|MID736|MID140|MID930|MID835|MID733|MID4X10",
	        "MSITablet": "MSI \\b(Primo 73K|Primo 73L|Primo 81L|Primo 77|Primo 93|Primo 75|Primo 76|Primo 73|Primo 81|Primo 91|Primo 90|Enjoy 71|Enjoy 7|Enjoy 10)\\b",
	        "SMiTTablet": "Android.*(\\bMID\\b|MID-560|MTV-T1200|MTV-PND531|MTV-P1101|MTV-PND530)",
	        "RockChipTablet": "Android.*(RK2818|RK2808A|RK2918|RK3066)|RK2738|RK2808A",
	        "FlyTablet": "IQ310|Fly Vision",
	        "bqTablet": "Android.*(bq)?.*(Elcano|Curie|Edison|Maxwell|Kepler|Pascal|Tesla|Hypatia|Platon|Newton|Livingstone|Cervantes|Avant|Aquaris [E|M]10)|Maxwell.*Lite|Maxwell.*Plus",
	        "HuaweiTablet": "MediaPad|MediaPad 7 Youth|IDEOS S7|S7-201c|S7-202u|S7-101|S7-103|S7-104|S7-105|S7-106|S7-201|S7-Slim",
	        "NecTablet": "\\bN-06D|\\bN-08D",
	        "PantechTablet": "Pantech.*P4100",
	        "BronchoTablet": "Broncho.*(N701|N708|N802|a710)",
	        "VersusTablet": "TOUCHPAD.*[78910]|\\bTOUCHTAB\\b",
	        "ZyncTablet": "z1000|Z99 2G|z99|z930|z999|z990|z909|Z919|z900",
	        "PositivoTablet": "TB07STA|TB10STA|TB07FTA|TB10FTA",
	        "NabiTablet": "Android.*\\bNabi",
	        "KoboTablet": "Kobo Touch|\\bK080\\b|\\bVox\\b Build|\\bArc\\b Build",
	        "DanewTablet": "DSlide.*\\b(700|701R|702|703R|704|802|970|971|972|973|974|1010|1012)\\b",
	        "TexetTablet": "NaviPad|TB-772A|TM-7045|TM-7055|TM-9750|TM-7016|TM-7024|TM-7026|TM-7041|TM-7043|TM-7047|TM-8041|TM-9741|TM-9747|TM-9748|TM-9751|TM-7022|TM-7021|TM-7020|TM-7011|TM-7010|TM-7023|TM-7025|TM-7037W|TM-7038W|TM-7027W|TM-9720|TM-9725|TM-9737W|TM-1020|TM-9738W|TM-9740|TM-9743W|TB-807A|TB-771A|TB-727A|TB-725A|TB-719A|TB-823A|TB-805A|TB-723A|TB-715A|TB-707A|TB-705A|TB-709A|TB-711A|TB-890HD|TB-880HD|TB-790HD|TB-780HD|TB-770HD|TB-721HD|TB-710HD|TB-434HD|TB-860HD|TB-840HD|TB-760HD|TB-750HD|TB-740HD|TB-730HD|TB-722HD|TB-720HD|TB-700HD|TB-500HD|TB-470HD|TB-431HD|TB-430HD|TB-506|TB-504|TB-446|TB-436|TB-416|TB-146SE|TB-126SE",
	        "PlaystationTablet": "Playstation.*(Portable|Vita)",
	        "TrekstorTablet": "ST10416-1|VT10416-1|ST70408-1|ST702xx-1|ST702xx-2|ST80208|ST97216|ST70104-2|VT10416-2|ST10216-2A|SurfTab",
	        "PyleAudioTablet": "\\b(PTBL10CEU|PTBL10C|PTBL72BC|PTBL72BCEU|PTBL7CEU|PTBL7C|PTBL92BC|PTBL92BCEU|PTBL9CEU|PTBL9CUK|PTBL9C)\\b",
	        "AdvanTablet": "Android.* \\b(E3A|T3X|T5C|T5B|T3E|T3C|T3B|T1J|T1F|T2A|T1H|T1i|E1C|T1-E|T5-A|T4|E1-B|T2Ci|T1-B|T1-D|O1-A|E1-A|T1-A|T3A|T4i)\\b ",
	        "DanyTechTablet": "Genius Tab G3|Genius Tab S2|Genius Tab Q3|Genius Tab G4|Genius Tab Q4|Genius Tab G-II|Genius TAB GII|Genius TAB GIII|Genius Tab S1",
	        "GalapadTablet": "Android.*\\bG1\\b",
	        "MicromaxTablet": "Funbook|Micromax.*\\b(P250|P560|P360|P362|P600|P300|P350|P500|P275)\\b",
	        "KarbonnTablet": "Android.*\\b(A39|A37|A34|ST8|ST10|ST7|Smart Tab3|Smart Tab2)\\b",
	        "AllFineTablet": "Fine7 Genius|Fine7 Shine|Fine7 Air|Fine8 Style|Fine9 More|Fine10 Joy|Fine11 Wide",
	        "PROSCANTablet": "\\b(PEM63|PLT1023G|PLT1041|PLT1044|PLT1044G|PLT1091|PLT4311|PLT4311PL|PLT4315|PLT7030|PLT7033|PLT7033D|PLT7035|PLT7035D|PLT7044K|PLT7045K|PLT7045KB|PLT7071KG|PLT7072|PLT7223G|PLT7225G|PLT7777G|PLT7810K|PLT7849G|PLT7851G|PLT7852G|PLT8015|PLT8031|PLT8034|PLT8036|PLT8080K|PLT8082|PLT8088|PLT8223G|PLT8234G|PLT8235G|PLT8816K|PLT9011|PLT9045K|PLT9233G|PLT9735|PLT9760G|PLT9770G)\\b",
	        "YONESTablet": "BQ1078|BC1003|BC1077|RK9702|BC9730|BC9001|IT9001|BC7008|BC7010|BC708|BC728|BC7012|BC7030|BC7027|BC7026",
	        "ChangJiaTablet": "TPC7102|TPC7103|TPC7105|TPC7106|TPC7107|TPC7201|TPC7203|TPC7205|TPC7210|TPC7708|TPC7709|TPC7712|TPC7110|TPC8101|TPC8103|TPC8105|TPC8106|TPC8203|TPC8205|TPC8503|TPC9106|TPC9701|TPC97101|TPC97103|TPC97105|TPC97106|TPC97111|TPC97113|TPC97203|TPC97603|TPC97809|TPC97205|TPC10101|TPC10103|TPC10106|TPC10111|TPC10203|TPC10205|TPC10503",
	        "GUTablet": "TX-A1301|TX-M9002|Q702|kf026",
	        "PointOfViewTablet": "TAB-P506|TAB-navi-7-3G-M|TAB-P517|TAB-P-527|TAB-P701|TAB-P703|TAB-P721|TAB-P731N|TAB-P741|TAB-P825|TAB-P905|TAB-P925|TAB-PR945|TAB-PL1015|TAB-P1025|TAB-PI1045|TAB-P1325|TAB-PROTAB[0-9]+|TAB-PROTAB25|TAB-PROTAB26|TAB-PROTAB27|TAB-PROTAB26XL|TAB-PROTAB2-IPS9|TAB-PROTAB30-IPS9|TAB-PROTAB25XXL|TAB-PROTAB26-IPS10|TAB-PROTAB30-IPS10",
	        "OvermaxTablet": "OV-(SteelCore|NewBase|Basecore|Baseone|Exellen|Quattor|EduTab|Solution|ACTION|BasicTab|TeddyTab|MagicTab|Stream|TB-08|TB-09)",
	        "HCLTablet": "HCL.*Tablet|Connect-3G-2.0|Connect-2G-2.0|ME Tablet U1|ME Tablet U2|ME Tablet G1|ME Tablet X1|ME Tablet Y2|ME Tablet Sync",
	        "DPSTablet": "DPS Dream 9|DPS Dual 7",
	        "VistureTablet": "V97 HD|i75 3G|Visture V4( HD)?|Visture V5( HD)?|Visture V10",
	        "CrestaTablet": "CTP(-)?810|CTP(-)?818|CTP(-)?828|CTP(-)?838|CTP(-)?888|CTP(-)?978|CTP(-)?980|CTP(-)?987|CTP(-)?988|CTP(-)?989",
	        "MediatekTablet": "\\bMT8125|MT8389|MT8135|MT8377\\b",
	        "ConcordeTablet": "Concorde([ ]+)?Tab|ConCorde ReadMan",
	        "GoCleverTablet": "GOCLEVER TAB|A7GOCLEVER|M1042|M7841|M742|R1042BK|R1041|TAB A975|TAB A7842|TAB A741|TAB A741L|TAB M723G|TAB M721|TAB A1021|TAB I921|TAB R721|TAB I720|TAB T76|TAB R70|TAB R76.2|TAB R106|TAB R83.2|TAB M813G|TAB I721|GCTA722|TAB I70|TAB I71|TAB S73|TAB R73|TAB R74|TAB R93|TAB R75|TAB R76.1|TAB A73|TAB A93|TAB A93.2|TAB T72|TAB R83|TAB R974|TAB R973|TAB A101|TAB A103|TAB A104|TAB A104.2|R105BK|M713G|A972BK|TAB A971|TAB R974.2|TAB R104|TAB R83.3|TAB A1042",
	        "ModecomTablet": "FreeTAB 9000|FreeTAB 7.4|FreeTAB 7004|FreeTAB 7800|FreeTAB 2096|FreeTAB 7.5|FreeTAB 1014|FreeTAB 1001 |FreeTAB 8001|FreeTAB 9706|FreeTAB 9702|FreeTAB 7003|FreeTAB 7002|FreeTAB 1002|FreeTAB 7801|FreeTAB 1331|FreeTAB 1004|FreeTAB 8002|FreeTAB 8014|FreeTAB 9704|FreeTAB 1003",
	        "VoninoTablet": "\\b(Argus[ _]?S|Diamond[ _]?79HD|Emerald[ _]?78E|Luna[ _]?70C|Onyx[ _]?S|Onyx[ _]?Z|Orin[ _]?HD|Orin[ _]?S|Otis[ _]?S|SpeedStar[ _]?S|Magnet[ _]?M9|Primus[ _]?94[ _]?3G|Primus[ _]?94HD|Primus[ _]?QS|Android.*\\bQ8\\b|Sirius[ _]?EVO[ _]?QS|Sirius[ _]?QS|Spirit[ _]?S)\\b",
	        "ECSTablet": "V07OT2|TM105A|S10OT1|TR10CS1",
	        "StorexTablet": "eZee[_']?(Tab|Go)[0-9]+|TabLC7|Looney Tunes Tab",
	        "VodafoneTablet": "SmartTab([ ]+)?[0-9]+|SmartTabII10|SmartTabII7|VF-1497",
	        "EssentielBTablet": "Smart[ ']?TAB[ ]+?[0-9]+|Family[ ']?TAB2",
	        "RossMoorTablet": "RM-790|RM-997|RMD-878G|RMD-974R|RMT-705A|RMT-701|RME-601|RMT-501|RMT-711",
	        "iMobileTablet": "i-mobile i-note",
	        "TolinoTablet": "tolino tab [0-9.]+|tolino shine",
	        "AudioSonicTablet": "\\bC-22Q|T7-QC|T-17B|T-17P\\b",
	        "AMPETablet": "Android.* A78 ",
	        "SkkTablet": "Android.* (SKYPAD|PHOENIX|CYCLOPS)",
	        "TecnoTablet": "TECNO P9",
	        "JXDTablet": "Android.* \\b(F3000|A3300|JXD5000|JXD3000|JXD2000|JXD300B|JXD300|S5800|S7800|S602b|S5110b|S7300|S5300|S602|S603|S5100|S5110|S601|S7100a|P3000F|P3000s|P101|P200s|P1000m|P200m|P9100|P1000s|S6600b|S908|P1000|P300|S18|S6600|S9100)\\b",
	        "iJoyTablet": "Tablet (Spirit 7|Essentia|Galatea|Fusion|Onix 7|Landa|Titan|Scooby|Deox|Stella|Themis|Argon|Unique 7|Sygnus|Hexen|Finity 7|Cream|Cream X2|Jade|Neon 7|Neron 7|Kandy|Scape|Saphyr 7|Rebel|Biox|Rebel|Rebel 8GB|Myst|Draco 7|Myst|Tab7-004|Myst|Tadeo Jones|Tablet Boing|Arrow|Draco Dual Cam|Aurix|Mint|Amity|Revolution|Finity 9|Neon 9|T9w|Amity 4GB Dual Cam|Stone 4GB|Stone 8GB|Andromeda|Silken|X2|Andromeda II|Halley|Flame|Saphyr 9,7|Touch 8|Planet|Triton|Unique 10|Hexen 10|Memphis 4GB|Memphis 8GB|Onix 10)",
	        "FX2Tablet": "FX2 PAD7|FX2 PAD10",
	        "XoroTablet": "KidsPAD 701|PAD[ ]?712|PAD[ ]?714|PAD[ ]?716|PAD[ ]?717|PAD[ ]?718|PAD[ ]?720|PAD[ ]?721|PAD[ ]?722|PAD[ ]?790|PAD[ ]?792|PAD[ ]?900|PAD[ ]?9715D|PAD[ ]?9716DR|PAD[ ]?9718DR|PAD[ ]?9719QR|PAD[ ]?9720QR|TelePAD1030|Telepad1032|TelePAD730|TelePAD731|TelePAD732|TelePAD735Q|TelePAD830|TelePAD9730|TelePAD795|MegaPAD 1331|MegaPAD 1851|MegaPAD 2151",
	        "ViewsonicTablet": "ViewPad 10pi|ViewPad 10e|ViewPad 10s|ViewPad E72|ViewPad7|ViewPad E100|ViewPad 7e|ViewSonic VB733|VB100a",
	        "OdysTablet": "LOOX|XENO10|ODYS[ -](Space|EVO|Xpress|NOON)|\\bXELIO\\b|Xelio10Pro|XELIO7PHONETAB|XELIO10EXTREME|XELIOPT2|NEO_QUAD10",
	        "CaptivaTablet": "CAPTIVA PAD",
	        "IconbitTablet": "NetTAB|NT-3702|NT-3702S|NT-3702S|NT-3603P|NT-3603P|NT-0704S|NT-0704S|NT-3805C|NT-3805C|NT-0806C|NT-0806C|NT-0909T|NT-0909T|NT-0907S|NT-0907S|NT-0902S|NT-0902S",
	        "TeclastTablet": "T98 4G|\\bP80\\b|\\bX90HD\\b|X98 Air|X98 Air 3G|\\bX89\\b|P80 3G|\\bX80h\\b|P98 Air|\\bX89HD\\b|P98 3G|\\bP90HD\\b|P89 3G|X98 3G|\\bP70h\\b|P79HD 3G|G18d 3G|\\bP79HD\\b|\\bP89s\\b|\\bA88\\b|\\bP10HD\\b|\\bP19HD\\b|G18 3G|\\bP78HD\\b|\\bA78\\b|\\bP75\\b|G17s 3G|G17h 3G|\\bP85t\\b|\\bP90\\b|\\bP11\\b|\\bP98t\\b|\\bP98HD\\b|\\bG18d\\b|\\bP85s\\b|\\bP11HD\\b|\\bP88s\\b|\\bA80HD\\b|\\bA80se\\b|\\bA10h\\b|\\bP89\\b|\\bP78s\\b|\\bG18\\b|\\bP85\\b|\\bA70h\\b|\\bA70\\b|\\bG17\\b|\\bP18\\b|\\bA80s\\b|\\bA11s\\b|\\bP88HD\\b|\\bA80h\\b|\\bP76s\\b|\\bP76h\\b|\\bP98\\b|\\bA10HD\\b|\\bP78\\b|\\bP88\\b|\\bA11\\b|\\bA10t\\b|\\bP76a\\b|\\bP76t\\b|\\bP76e\\b|\\bP85HD\\b|\\bP85a\\b|\\bP86\\b|\\bP75HD\\b|\\bP76v\\b|\\bA12\\b|\\bP75a\\b|\\bA15\\b|\\bP76Ti\\b|\\bP81HD\\b|\\bA10\\b|\\bT760VE\\b|\\bT720HD\\b|\\bP76\\b|\\bP73\\b|\\bP71\\b|\\bP72\\b|\\bT720SE\\b|\\bC520Ti\\b|\\bT760\\b|\\bT720VE\\b|T720-3GE|T720-WiFi",
	        "OndaTablet": "\\b(V975i|Vi30|VX530|V701|Vi60|V701s|Vi50|V801s|V719|Vx610w|VX610W|V819i|Vi10|VX580W|Vi10|V711s|V813|V811|V820w|V820|Vi20|V711|VI30W|V712|V891w|V972|V819w|V820w|Vi60|V820w|V711|V813s|V801|V819|V975s|V801|V819|V819|V818|V811|V712|V975m|V101w|V961w|V812|V818|V971|V971s|V919|V989|V116w|V102w|V973|Vi40)\\b[\\s]+",
	        "JaytechTablet": "TPC-PA762",
	        "BlaupunktTablet": "Endeavour 800NG|Endeavour 1010",
	        "DigmaTablet": "\\b(iDx10|iDx9|iDx8|iDx7|iDxD7|iDxD8|iDsQ8|iDsQ7|iDsQ8|iDsD10|iDnD7|3TS804H|iDsQ11|iDj7|iDs10)\\b",
	        "EvolioTablet": "ARIA_Mini_wifi|Aria[ _]Mini|Evolio X10|Evolio X7|Evolio X8|\\bEvotab\\b|\\bNeura\\b",
	        "LavaTablet": "QPAD E704|\\bIvoryS\\b|E-TAB IVORY|\\bE-TAB\\b",
	        "AocTablet": "MW0811|MW0812|MW0922|MTK8382|MW1031|MW0831|MW0821|MW0931|MW0712",
	        "MpmanTablet": "MP11 OCTA|MP10 OCTA|MPQC1114|MPQC1004|MPQC994|MPQC974|MPQC973|MPQC804|MPQC784|MPQC780|\\bMPG7\\b|MPDCG75|MPDCG71|MPDC1006|MP101DC|MPDC9000|MPDC905|MPDC706HD|MPDC706|MPDC705|MPDC110|MPDC100|MPDC99|MPDC97|MPDC88|MPDC8|MPDC77|MP709|MID701|MID711|MID170|MPDC703|MPQC1010",
	        "CelkonTablet": "CT695|CT888|CT[\\s]?910|CT7 Tab|CT9 Tab|CT3 Tab|CT2 Tab|CT1 Tab|C820|C720|\\bCT-1\\b",
	        "WolderTablet": "miTab \\b(DIAMOND|SPACE|BROOKLYN|NEO|FLY|MANHATTAN|FUNK|EVOLUTION|SKY|GOCAR|IRON|GENIUS|POP|MINT|EPSILON|BROADWAY|JUMP|HOP|LEGEND|NEW AGE|LINE|ADVANCE|FEEL|FOLLOW|LIKE|LINK|LIVE|THINK|FREEDOM|CHICAGO|CLEVELAND|BALTIMORE-GH|IOWA|BOSTON|SEATTLE|PHOENIX|DALLAS|IN 101|MasterChef)\\b",
	        "MiTablet": "\\bMI PAD\\b|\\bHM NOTE 1W\\b",
	        "NibiruTablet": "Nibiru M1|Nibiru Jupiter One",
	        "NexoTablet": "NEXO NOVA|NEXO 10|NEXO AVIO|NEXO FREE|NEXO GO|NEXO EVO|NEXO 3G|NEXO SMART|NEXO KIDDO|NEXO MOBI",
	        "LeaderTablet": "TBLT10Q|TBLT10I|TBL-10WDKB|TBL-10WDKBO2013|TBL-W230V2|TBL-W450|TBL-W500|SV572|TBLT7I|TBA-AC7-8G|TBLT79|TBL-8W16|TBL-10W32|TBL-10WKB|TBL-W100",
	        "UbislateTablet": "UbiSlate[\\s]?7C",
	        "PocketBookTablet": "Pocketbook",
	        "KocasoTablet": "\\b(TB-1207)\\b",
	        "HisenseTablet": "\\b(F5281|E2371)\\b",
	        "Hudl": "Hudl HT7S3|Hudl 2",
	        "TelstraTablet": "T-Hub2",
	        "GenericTablet": "Android.*\\b97D\\b|Tablet(?!.*PC)|BNTV250A|MID-WCDMA|LogicPD Zoom2|\\bA7EB\\b|CatNova8|A1_07|CT704|CT1002|\\bM721\\b|rk30sdk|\\bEVOTAB\\b|M758A|ET904|ALUMIUM10|Smartfren Tab|Endeavour 1010|Tablet-PC-4|Tagi Tab|\\bM6pro\\b|CT1020W|arc 10HD|\\bTP750\\b|\\bQTAQZ3\\b"
	    },
	    "oss": {
	        "AndroidOS": "Android",
	        "BlackBerryOS": "blackberry|\\bBB10\\b|rim tablet os",
	        "PalmOS": "PalmOS|avantgo|blazer|elaine|hiptop|palm|plucker|xiino",
	        "SymbianOS": "Symbian|SymbOS|Series60|Series40|SYB-[0-9]+|\\bS60\\b",
	        "WindowsMobileOS": "Windows CE.*(PPC|Smartphone|Mobile|[0-9]{3}x[0-9]{3})|Window Mobile|Windows Phone [0-9.]+|WCE;",
	        "WindowsPhoneOS": "Windows Phone 10.0|Windows Phone 8.1|Windows Phone 8.0|Windows Phone OS|XBLWP7|ZuneWP7|Windows NT 6.[23]; ARM;",
	        "iOS": "\\biPhone.*Mobile|\\biPod|\\biPad",
	        "MeeGoOS": "MeeGo",
	        "MaemoOS": "Maemo",
	        "JavaOS": "J2ME\/|\\bMIDP\\b|\\bCLDC\\b",
	        "webOS": "webOS|hpwOS",
	        "badaOS": "\\bBada\\b",
	        "BREWOS": "BREW"
	    },
	    "uas": {
	        "Chrome": "\\bCrMo\\b|CriOS|Android.*Chrome\/[.0-9]* (Mobile)?",
	        "Dolfin": "\\bDolfin\\b",
	        "Opera": "Opera.*Mini|Opera.*Mobi|Android.*Opera|Mobile.*OPR\/[0-9.]+|Coast\/[0-9.]+",
	        "Skyfire": "Skyfire",
	        "Edge": "Mobile Safari\/[.0-9]* Edge",
	        "IE": "IEMobile|MSIEMobile",
	        "Firefox": "fennec|firefox.*maemo|(Mobile|Tablet).*Firefox|Firefox.*Mobile|FxiOS",
	        "Bolt": "bolt",
	        "TeaShark": "teashark",
	        "Blazer": "Blazer",
	        "Safari": "Version.*Mobile.*Safari|Safari.*Mobile|MobileSafari",
	        "UCBrowser": "UC.*Browser|UCWEB",
	        "baiduboxapp": "baiduboxapp",
	        "baidubrowser": "baidubrowser",
	        "DiigoBrowser": "DiigoBrowser",
	        "Puffin": "Puffin",
	        "Mercury": "\\bMercury\\b",
	        "ObigoBrowser": "Obigo",
	        "NetFront": "NF-Browser",
	        "GenericBrowser": "NokiaBrowser|OviBrowser|OneBrowser|TwonkyBeamBrowser|SEMC.*Browser|FlyFlow|Minimo|NetFront|Novarra-Vision|MQQBrowser|MicroMessenger",
	        "PaleMoon": "Android.*PaleMoon|Mobile.*PaleMoon"
	    },
	    "props": {
	        "Mobile": "Mobile\/[VER]",
	        "Build": "Build\/[VER]",
	        "Version": "Version\/[VER]",
	        "VendorID": "VendorID\/[VER]",
	        "iPad": "iPad.*CPU[a-z ]+[VER]",
	        "iPhone": "iPhone.*CPU[a-z ]+[VER]",
	        "iPod": "iPod.*CPU[a-z ]+[VER]",
	        "Kindle": "Kindle\/[VER]",
	        "Chrome": [
	            "Chrome\/[VER]",
	            "CriOS\/[VER]",
	            "CrMo\/[VER]"
	        ],
	        "Coast": [
	            "Coast\/[VER]"
	        ],
	        "Dolfin": "Dolfin\/[VER]",
	        "Firefox": [
	            "Firefox\/[VER]",
	            "FxiOS\/[VER]"
	        ],
	        "Fennec": "Fennec\/[VER]",
	        "Edge": "Edge\/[VER]",
	        "IE": [
	            "IEMobile\/[VER];",
	            "IEMobile [VER]",
	            "MSIE [VER];",
	            "Trident\/[0-9.]+;.*rv:[VER]"
	        ],
	        "NetFront": "NetFront\/[VER]",
	        "NokiaBrowser": "NokiaBrowser\/[VER]",
	        "Opera": [
	            " OPR\/[VER]",
	            "Opera Mini\/[VER]",
	            "Version\/[VER]"
	        ],
	        "Opera Mini": "Opera Mini\/[VER]",
	        "Opera Mobi": "Version\/[VER]",
	        "UC Browser": "UC Browser[VER]",
	        "MQQBrowser": "MQQBrowser\/[VER]",
	        "MicroMessenger": "MicroMessenger\/[VER]",
	        "baiduboxapp": "baiduboxapp\/[VER]",
	        "baidubrowser": "baidubrowser\/[VER]",
	        "SamsungBrowser": "SamsungBrowser\/[VER]",
	        "Iron": "Iron\/[VER]",
	        "Safari": [
	            "Version\/[VER]",
	            "Safari\/[VER]"
	        ],
	        "Skyfire": "Skyfire\/[VER]",
	        "Tizen": "Tizen\/[VER]",
	        "Webkit": "webkit[ \/][VER]",
	        "PaleMoon": "PaleMoon\/[VER]",
	        "Gecko": "Gecko\/[VER]",
	        "Trident": "Trident\/[VER]",
	        "Presto": "Presto\/[VER]",
	        "Goanna": "Goanna\/[VER]",
	        "iOS": " \\bi?OS\\b [VER][ ;]{1}",
	        "Android": "Android [VER]",
	        "BlackBerry": [
	            "BlackBerry[\\w]+\/[VER]",
	            "BlackBerry.*Version\/[VER]",
	            "Version\/[VER]"
	        ],
	        "BREW": "BREW [VER]",
	        "Java": "Java\/[VER]",
	        "Windows Phone OS": [
	            "Windows Phone OS [VER]",
	            "Windows Phone [VER]"
	        ],
	        "Windows Phone": "Windows Phone [VER]",
	        "Windows CE": "Windows CE\/[VER]",
	        "Windows NT": "Windows NT [VER]",
	        "Symbian": [
	            "SymbianOS\/[VER]",
	            "Symbian\/[VER]"
	        ],
	        "webOS": [
	            "webOS\/[VER]",
	            "hpwOS\/[VER];"
	        ]
	    },
	    "utils": {
	        "Bot": "Googlebot|facebookexternalhit|AdsBot-Google|Google Keyword Suggestion|Facebot|YandexBot|YandexMobileBot|bingbot|ia_archiver|AhrefsBot|Ezooms|GSLFbot|WBSearchBot|Twitterbot|TweetmemeBot|Twikle|PaperLiBot|Wotbox|UnwindFetchor|Exabot|MJ12bot|YandexImages|TurnitinBot|Pingdom",
	        "MobileBot": "Googlebot-Mobile|AdsBot-Google-Mobile|YahooSeeker\/M1A1-R2D2",
	        "DesktopMode": "WPDesktop",
	        "TV": "SonyDTV|HbbTV",
	        "WebKit": "(webkit)[ \/]([\\w.]+)",
	        "Console": "\\b(Nintendo|Nintendo WiiU|Nintendo 3DS|PLAYSTATION|Xbox)\\b",
	        "Watch": "SM-V700"
	    }
	};
	
	    // following patterns come from http://detectmobilebrowsers.com/
	    impl.detectMobileBrowsers = {
	        fullPattern: /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,
	        shortPattern: /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
	        tabletPattern: /android|ipad|playbook|silk/i
	    };
	
	    var hasOwnProp = Object.prototype.hasOwnProperty,
	        isArray;
	
	    impl.FALLBACK_PHONE = 'UnknownPhone';
	    impl.FALLBACK_TABLET = 'UnknownTablet';
	    impl.FALLBACK_MOBILE = 'UnknownMobile';
	
	    isArray = ('isArray' in Array) ?
	        Array.isArray : function (value) { return Object.prototype.toString.call(value) === '[object Array]'; };
	
	    function equalIC(a, b) {
	        return a != null && b != null && a.toLowerCase() === b.toLowerCase();
	    }
	
	    function containsIC(array, value) {
	        var valueLC, i, len = array.length;
	        if (!len || !value) {
	            return false;
	        }
	        valueLC = value.toLowerCase();
	        for (i = 0; i < len; ++i) {
	            if (valueLC === array[i].toLowerCase()) {
	                return true;
	            }
	        }
	        return false;
	    }
	
	    function convertPropsToRegExp(object) {
	        for (var key in object) {
	            if (hasOwnProp.call(object, key)) {
	                object[key] = new RegExp(object[key], 'i');
	            }
	        }
	    }
	
	    (function init() {
	        var key, values, value, i, len, verPos, mobileDetectRules = impl.mobileDetectRules;
	        for (key in mobileDetectRules.props) {
	            if (hasOwnProp.call(mobileDetectRules.props, key)) {
	                values = mobileDetectRules.props[key];
	                if (!isArray(values)) {
	                    values = [values];
	                }
	                len = values.length;
	                for (i = 0; i < len; ++i) {
	                    value = values[i];
	                    verPos = value.indexOf('[VER]');
	                    if (verPos >= 0) {
	                        value = value.substring(0, verPos) + '([\\w._\\+]+)' + value.substring(verPos + 5);
	                    }
	                    values[i] = new RegExp(value, 'i');
	                }
	                mobileDetectRules.props[key] = values;
	            }
	        }
	        convertPropsToRegExp(mobileDetectRules.oss);
	        convertPropsToRegExp(mobileDetectRules.phones);
	        convertPropsToRegExp(mobileDetectRules.tablets);
	        convertPropsToRegExp(mobileDetectRules.uas);
	        convertPropsToRegExp(mobileDetectRules.utils);
	
	        // copy some patterns to oss0 which are tested first (see issue#15)
	        mobileDetectRules.oss0 = {
	            WindowsPhoneOS: mobileDetectRules.oss.WindowsPhoneOS,
	            WindowsMobileOS: mobileDetectRules.oss.WindowsMobileOS
	        };
	    }());
	
	    /**
	     * Test userAgent string against a set of rules and find the first matched key.
	     * @param {Object} rules (key is String, value is RegExp)
	     * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
	     * @returns {String|null} the matched key if found, otherwise <tt>null</tt>
	     * @private
	     */
	    impl.findMatch = function(rules, userAgent) {
	        for (var key in rules) {
	            if (hasOwnProp.call(rules, key)) {
	                if (rules[key].test(userAgent)) {
	                    return key;
	                }
	            }
	        }
	        return null;
	    };
	
	    /**
	     * Test userAgent string against a set of rules and return an array of matched keys.
	     * @param {Object} rules (key is String, value is RegExp)
	     * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
	     * @returns {Array} an array of matched keys, may be empty when there is no match, but not <tt>null</tt>
	     * @private
	     */
	    impl.findMatches = function(rules, userAgent) {
	        var result = [];
	        for (var key in rules) {
	            if (hasOwnProp.call(rules, key)) {
	                if (rules[key].test(userAgent)) {
	                    result.push(key);
	                }
	            }
	        }
	        return result;
	    };
	
	    /**
	     * Check the version of the given property in the User-Agent.
	     *
	     * @param {String} propertyName
	     * @param {String} userAgent
	     * @return {String} version or <tt>null</tt> if version not found
	     * @private
	     */
	    impl.getVersionStr = function (propertyName, userAgent) {
	        var props = impl.mobileDetectRules.props, patterns, i, len, match;
	        if (hasOwnProp.call(props, propertyName)) {
	            patterns = props[propertyName];
	            len = patterns.length;
	            for (i = 0; i < len; ++i) {
	                match = patterns[i].exec(userAgent);
	                if (match !== null) {
	                    return match[1];
	                }
	            }
	        }
	        return null;
	    };
	
	    /**
	     * Check the version of the given property in the User-Agent.
	     * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
	     *
	     * @param {String} propertyName
	     * @param {String} userAgent
	     * @return {Number} version or <tt>NaN</tt> if version not found
	     * @private
	     */
	    impl.getVersion = function (propertyName, userAgent) {
	        var version = impl.getVersionStr(propertyName, userAgent);
	        return version ? impl.prepareVersionNo(version) : NaN;
	    };
	
	    /**
	     * Prepare the version number.
	     *
	     * @param {String} version
	     * @return {Number} the version number as a floating number
	     * @private
	     */
	    impl.prepareVersionNo = function (version) {
	        var numbers;
	
	        numbers = version.split(/[a-z._ \/\-]/i);
	        if (numbers.length === 1) {
	            version = numbers[0];
	        }
	        if (numbers.length > 1) {
	            version = numbers[0] + '.';
	            numbers.shift();
	            version += numbers.join('');
	        }
	        return Number(version);
	    };
	
	    impl.isMobileFallback = function (userAgent) {
	        return impl.detectMobileBrowsers.fullPattern.test(userAgent) ||
	            impl.detectMobileBrowsers.shortPattern.test(userAgent.substr(0,4));
	    };
	
	    impl.isTabletFallback = function (userAgent) {
	        return impl.detectMobileBrowsers.tabletPattern.test(userAgent);
	    };
	
	    impl.prepareDetectionCache = function (cache, userAgent, maxPhoneWidth) {
	        if (cache.mobile !== undefined) {
	            return;
	        }
	        var phone, tablet, phoneSized;
	
	        // first check for stronger tablet rules, then phone (see issue#5)
	        tablet = impl.findMatch(impl.mobileDetectRules.tablets, userAgent);
	        if (tablet) {
	            cache.mobile = cache.tablet = tablet;
	            cache.phone = null;
	            return; // unambiguously identified as tablet
	        }
	
	        phone = impl.findMatch(impl.mobileDetectRules.phones, userAgent);
	        if (phone) {
	            cache.mobile = cache.phone = phone;
	            cache.tablet = null;
	            return; // unambiguously identified as phone
	        }
	
	        // our rules haven't found a match -> try more general fallback rules
	        if (impl.isMobileFallback(userAgent)) {
	            phoneSized = MobileDetect.isPhoneSized(maxPhoneWidth);
	            if (phoneSized === undefined) {
	                cache.mobile = impl.FALLBACK_MOBILE;
	                cache.tablet = cache.phone = null;
	            } else if (phoneSized) {
	                cache.mobile = cache.phone = impl.FALLBACK_PHONE;
	                cache.tablet = null;
	            } else {
	                cache.mobile = cache.tablet = impl.FALLBACK_TABLET;
	                cache.phone = null;
	            }
	        } else if (impl.isTabletFallback(userAgent)) {
	            cache.mobile = cache.tablet = impl.FALLBACK_TABLET;
	            cache.phone = null;
	        } else {
	            // not mobile at all!
	            cache.mobile = cache.tablet = cache.phone = null;
	        }
	    };
	
	    // t is a reference to a MobileDetect instance
	    impl.mobileGrade = function (t) {
	        // impl note:
	        // To keep in sync w/ Mobile_Detect.php easily, the following code is tightly aligned to the PHP version.
	        // When changes are made in Mobile_Detect.php, copy this method and replace:
	        //     $this-> / t.
	        //     self::MOBILE_GRADE_(.) / '$1'
	        //     , self::VERSION_TYPE_FLOAT / (nothing)
	        //     isIOS() / os('iOS')
	        //     [reg] / (nothing)   <-- jsdelivr complaining about unescaped unicode character U+00AE
	        var $isMobile = t.mobile() !== null;
	
	        if (
	            // Apple iOS 3.2-5.1 - Tested on the original iPad (4.3 / 5.0), iPad 2 (4.3), iPad 3 (5.1), original iPhone (3.1), iPhone 3 (3.2), 3GS (4.3), 4 (4.3 / 5.0), and 4S (5.1)
	            t.os('iOS') && t.version('iPad')>=4.3 ||
	            t.os('iOS') && t.version('iPhone')>=3.1 ||
	            t.os('iOS') && t.version('iPod')>=3.1 ||
	
	            // Android 2.1-2.3 - Tested on the HTC Incredible (2.2), original Droid (2.2), HTC Aria (2.1), Google Nexus S (2.3). Functional on 1.5 & 1.6 but performance may be sluggish, tested on Google G1 (1.5)
	            // Android 3.1 (Honeycomb)  - Tested on the Samsung Galaxy Tab 10.1 and Motorola XOOM
	            // Android 4.0 (ICS)  - Tested on a Galaxy Nexus. Note: transition performance can be poor on upgraded devices
	            // Android 4.1 (Jelly Bean)  - Tested on a Galaxy Nexus and Galaxy 7
	            ( t.version('Android')>2.1 && t.is('Webkit') ) ||
	
	            // Windows Phone 7-7.5 - Tested on the HTC Surround (7.0) HTC Trophy (7.5), LG-E900 (7.5), Nokia Lumia 800
	            t.version('Windows Phone OS')>=7.0 ||
	
	            // Blackberry 7 - Tested on BlackBerry Torch 9810
	            // Blackberry 6.0 - Tested on the Torch 9800 and Style 9670
	            t.is('BlackBerry') && t.version('BlackBerry')>=6.0 ||
	            // Blackberry Playbook (1.0-2.0) - Tested on PlayBook
	            t.match('Playbook.*Tablet') ||
	
	            // Palm WebOS (1.4-2.0) - Tested on the Palm Pixi (1.4), Pre (1.4), Pre 2 (2.0)
	            ( t.version('webOS')>=1.4 && t.match('Palm|Pre|Pixi') ) ||
	            // Palm WebOS 3.0  - Tested on HP TouchPad
	            t.match('hp.*TouchPad') ||
	
	            // Firefox Mobile (12 Beta) - Tested on Android 2.3 device
	            ( t.is('Firefox') && t.version('Firefox')>=12 ) ||
	
	            // Chrome for Android - Tested on Android 4.0, 4.1 device
	            ( t.is('Chrome') && t.is('AndroidOS') && t.version('Android')>=4.0 ) ||
	
	            // Skyfire 4.1 - Tested on Android 2.3 device
	            ( t.is('Skyfire') && t.version('Skyfire')>=4.1 && t.is('AndroidOS') && t.version('Android')>=2.3 ) ||
	
	            // Opera Mobile 11.5-12: Tested on Android 2.3
	            ( t.is('Opera') && t.version('Opera Mobi')>11 && t.is('AndroidOS') ) ||
	
	            // Meego 1.2 - Tested on Nokia 950 and N9
	            t.is('MeeGoOS') ||
	
	            // Tizen (pre-release) - Tested on early hardware
	            t.is('Tizen') ||
	
	            // Samsung Bada 2.0 - Tested on a Samsung Wave 3, Dolphin browser
	            // @todo: more tests here!
	            t.is('Dolfin') && t.version('Bada')>=2.0 ||
	
	            // UC Browser - Tested on Android 2.3 device
	            ( (t.is('UC Browser') || t.is('Dolfin')) && t.version('Android')>=2.3 ) ||
	
	            // Kindle 3 and Fire  - Tested on the built-in WebKit browser for each
	            ( t.match('Kindle Fire') ||
	                t.is('Kindle') && t.version('Kindle')>=3.0 ) ||
	
	            // Nook Color 1.4.1 - Tested on original Nook Color, not Nook Tablet
	            t.is('AndroidOS') && t.is('NookTablet') ||
	
	            // Chrome Desktop 11-21 - Tested on OS X 10.7 and Windows 7
	            t.version('Chrome')>=11 && !$isMobile ||
	
	            // Safari Desktop 4-5 - Tested on OS X 10.7 and Windows 7
	            t.version('Safari')>=5.0 && !$isMobile ||
	
	            // Firefox Desktop 4-13 - Tested on OS X 10.7 and Windows 7
	            t.version('Firefox')>=4.0 && !$isMobile ||
	
	            // Internet Explorer 7-9 - Tested on Windows XP, Vista and 7
	            t.version('MSIE')>=7.0 && !$isMobile ||
	
	            // Opera Desktop 10-12 - Tested on OS X 10.7 and Windows 7
	            // @reference: http://my.opera.com/community/openweb/idopera/
	            t.version('Opera')>=10 && !$isMobile
	
	            ){
	            return 'A';
	        }
	
	        if (
	            t.os('iOS') && t.version('iPad')<4.3 ||
	            t.os('iOS') && t.version('iPhone')<3.1 ||
	            t.os('iOS') && t.version('iPod')<3.1 ||
	
	            // Blackberry 5.0: Tested on the Storm 2 9550, Bold 9770
	            t.is('Blackberry') && t.version('BlackBerry')>=5 && t.version('BlackBerry')<6 ||
	
	            //Opera Mini (5.0-6.5) - Tested on iOS 3.2/4.3 and Android 2.3
	            ( t.version('Opera Mini')>=5.0 && t.version('Opera Mini')<=6.5 &&
	                (t.version('Android')>=2.3 || t.is('iOS')) ) ||
	
	            // Nokia Symbian^3 - Tested on Nokia N8 (Symbian^3), C7 (Symbian^3), also works on N97 (Symbian^1)
	            t.match('NokiaN8|NokiaC7|N97.*Series60|Symbian/3') ||
	
	            // @todo: report this (tested on Nokia N71)
	            t.version('Opera Mobi')>=11 && t.is('SymbianOS')
	            ){
	            return 'B';
	        }
	
	        if (
	        // Blackberry 4.x - Tested on the Curve 8330
	            t.version('BlackBerry')<5.0 ||
	            // Windows Mobile - Tested on the HTC Leo (WinMo 5.2)
	            t.match('MSIEMobile|Windows CE.*Mobile') || t.version('Windows Mobile')<=5.2
	
	            ){
	            return 'C';
	        }
	
	        //All older smartphone platforms and featurephones - Any device that doesn't support media queries
	        //will receive the basic, C grade experience.
	        return 'C';
	    };
	
	    impl.detectOS = function (ua) {
	        return impl.findMatch(impl.mobileDetectRules.oss0, ua) ||
	            impl.findMatch(impl.mobileDetectRules.oss, ua);
	    };
	
	    impl.getDeviceSmallerSide = function () {
	        return window.screen.width < window.screen.height ?
	            window.screen.width :
	            window.screen.height;
	    };
	
	    /**
	     * Constructor for MobileDetect object.
	     * <br>
	     * Such an object will keep a reference to the given user-agent string and cache most of the detect queries.<br>
	     * <div style="background-color: #d9edf7; border: 1px solid #bce8f1; color: #3a87ad; padding: 14px; border-radius: 2px; margin-top: 20px">
	     *     <strong>Find information how to download and install:</strong>
	     *     <a href="https://github.com/hgoebl/mobile-detect.js/">github.com/hgoebl/mobile-detect.js/</a>
	     * </div>
	     *
	     * @example <pre>
	     *     var md = new MobileDetect(window.navigator.userAgent);
	     *     if (md.mobile()) {
	     *         location.href = (md.mobileGrade() === 'A') ? '/mobile/' : '/lynx/';
	     *     }
	     * </pre>
	     *
	     * @param {string} userAgent typically taken from window.navigator.userAgent or http_header['User-Agent']
	     * @param {number} [maxPhoneWidth=600] <strong>only for browsers</strong> specify a value for the maximum
	     *        width of smallest device side (in logical "CSS" pixels) until a device detected as mobile will be handled
	     *        as phone.
	     *        This is only used in cases where the device cannot be classified as phone or tablet.<br>
	     *        See <a href="http://developer.android.com/guide/practices/screens_support.html">Declaring Tablet Layouts
	     *        for Android</a>.<br>
	     *        If you provide a value < 0, then this "fuzzy" check is disabled.
	     * @constructor
	     * @global
	     */
	    function MobileDetect(userAgent, maxPhoneWidth) {
	        this.ua = userAgent || '';
	        this._cache = {};
	        //600dp is typical 7" tablet minimum width
	        this.maxPhoneWidth = maxPhoneWidth || 600;
	    }
	
	    MobileDetect.prototype = {
	        constructor: MobileDetect,
	
	        /**
	         * Returns the detected phone or tablet type or <tt>null</tt> if it is not a mobile device.
	         * <br>
	         * For a list of possible return values see {@link MobileDetect#phone} and {@link MobileDetect#tablet}.<br>
	         * <br>
	         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
	         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
	         * is positive, a value of <code>UnknownPhone</code>, <code>UnknownTablet</code> or
	         * <code>UnknownMobile</code> is returned.<br>
	         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
	         * <br>
	         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
	         * and <code>UnknownMobile</code>, so you will get <code>UnknownMobile</code> here.<br>
	         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
	         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
	         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
	         * <br>
	         * In most cases you will use the return value just as a boolean.
	         *
	         * @returns {String} the key for the phone family or tablet family, e.g. "Nexus".
	         * @function MobileDetect#mobile
	         */
	        mobile: function () {
	            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
	            return this._cache.mobile;
	        },
	
	        /**
	         * Returns the detected phone type/family string or <tt>null</tt>.
	         * <br>
	         * The returned tablet (family or producer) is one of following keys:<br>
	         * <br><tt>iPhone, BlackBerry, HTC, Nexus, Dell, Motorola, Samsung, LG, Sony, Asus,
	         * NokiaLumia, Micromax, Palm, Vertu, Pantech, Fly, Wiko, iMobile, SimValley,
	         * Wolfgang, Alcatel, Nintendo, Amoi, INQ, GenericPhone</tt><br>
	         * <br>
	         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
	         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
	         * is positive, a value of <code>UnknownPhone</code> or <code>UnknownMobile</code> is returned.<br>
	         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
	         * <br>
	         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
	         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
	         * will return <code>UnknownMobile</code>.<br>
	         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
	         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
	         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
	         * <br>
	         * In most cases you will use the return value just as a boolean.
	         *
	         * @returns {String} the key of the phone family or producer, e.g. "iPhone"
	         * @function MobileDetect#phone
	         */
	        phone: function () {
	            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
	            return this._cache.phone;
	        },
	
	        /**
	         * Returns the detected tablet type/family string or <tt>null</tt>.
	         * <br>
	         * The returned tablet (family or producer) is one of following keys:<br>
	         * <br><tt>iPad, NexusTablet, SamsungTablet, Kindle, SurfaceTablet, HPTablet, AsusTablet,
	         * BlackBerryTablet, HTCtablet, MotorolaTablet, NookTablet, AcerTablet,
	         * ToshibaTablet, LGTablet, FujitsuTablet, PrestigioTablet, LenovoTablet,
	         * DellTablet, YarvikTablet, MedionTablet, ArnovaTablet, IntensoTablet, IRUTablet,
	         * MegafonTablet, EbodaTablet, AllViewTablet, ArchosTablet, AinolTablet,
	         * NokiaLumiaTablet, SonyTablet, PhilipsTablet, CubeTablet, CobyTablet, MIDTablet,
	         * MSITablet, SMiTTablet, RockChipTablet, FlyTablet, bqTablet, HuaweiTablet,
	         * NecTablet, PantechTablet, BronchoTablet, VersusTablet, ZyncTablet,
	         * PositivoTablet, NabiTablet, KoboTablet, DanewTablet, TexetTablet,
	         * PlaystationTablet, TrekstorTablet, PyleAudioTablet, AdvanTablet,
	         * DanyTechTablet, GalapadTablet, MicromaxTablet, KarbonnTablet, AllFineTablet,
	         * PROSCANTablet, YONESTablet, ChangJiaTablet, GUTablet, PointOfViewTablet,
	         * OvermaxTablet, HCLTablet, DPSTablet, VistureTablet, CrestaTablet,
	         * MediatekTablet, ConcordeTablet, GoCleverTablet, ModecomTablet, VoninoTablet,
	         * ECSTablet, StorexTablet, VodafoneTablet, EssentielBTablet, RossMoorTablet,
	         * iMobileTablet, TolinoTablet, AudioSonicTablet, AMPETablet, SkkTablet,
	         * TecnoTablet, JXDTablet, iJoyTablet, FX2Tablet, XoroTablet, ViewsonicTablet,
	         * OdysTablet, CaptivaTablet, IconbitTablet, TeclastTablet, OndaTablet,
	         * JaytechTablet, BlaupunktTablet, DigmaTablet, EvolioTablet, LavaTablet,
	         * AocTablet, MpmanTablet, CelkonTablet, WolderTablet, MiTablet, NibiruTablet,
	         * NexoTablet, LeaderTablet, UbislateTablet, PocketBookTablet, KocasoTablet,
	         * HisenseTablet, Hudl, TelstraTablet, GenericTablet</tt><br>
	         * <br>
	         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
	         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
	         * is positive, a value of <code>UnknownTablet</code> or <code>UnknownMobile</code> is returned.<br>
	         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
	         * <br>
	         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
	         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
	         * will return <code>UnknownMobile</code>.<br>
	         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
	         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
	         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
	         * <br>
	         * In most cases you will use the return value just as a boolean.
	         *
	         * @returns {String} the key of the tablet family or producer, e.g. "SamsungTablet"
	         * @function MobileDetect#tablet
	         */
	        tablet: function () {
	            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
	            return this._cache.tablet;
	        },
	
	        /**
	         * Returns the (first) detected user-agent string or <tt>null</tt>.
	         * <br>
	         * The returned user-agent is one of following keys:<br>
	         * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
	         * Safari, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Puffin, Mercury,
	         * ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
	         * <br>
	         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
	         * cases where a mobile device pretends to be more than one particular browser. You can get the
	         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
	         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
	         *
	         * @returns {String} the key for the detected user-agent or <tt>null</tt>
	         * @function MobileDetect#userAgent
	         */
	        userAgent: function () {
	            if (this._cache.userAgent === undefined) {
	                this._cache.userAgent = impl.findMatch(impl.mobileDetectRules.uas, this.ua);
	            }
	            return this._cache.userAgent;
	        },
	
	        /**
	         * Returns all detected user-agent strings.
	         * <br>
	         * The array is empty or contains one or more of following keys:<br>
	         * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
	         * Safari, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Puffin, Mercury,
	         * ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
	         * <br>
	         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
	         * cases where a mobile device pretends to be more than one particular browser. You can get the
	         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
	         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
	         *
	         * @returns {Array} the array of detected user-agent keys or <tt>[]</tt>
	         * @function MobileDetect#userAgents
	         */
	        userAgents: function () {
	            if (this._cache.userAgents === undefined) {
	                this._cache.userAgents = impl.findMatches(impl.mobileDetectRules.uas, this.ua);
	            }
	            return this._cache.userAgents;
	        },
	
	        /**
	         * Returns the detected operating system string or <tt>null</tt>.
	         * <br>
	         * The operating system is one of following keys:<br>
	         * <br><tt>AndroidOS, BlackBerryOS, PalmOS, SymbianOS, WindowsMobileOS, WindowsPhoneOS,
	         * iOS, MeeGoOS, MaemoOS, JavaOS, webOS, badaOS, BREWOS</tt><br>
	         *
	         * @returns {String} the key for the detected operating system.
	         * @function MobileDetect#os
	         */
	        os: function () {
	            if (this._cache.os === undefined) {
	                this._cache.os = impl.detectOS(this.ua);
	            }
	            return this._cache.os;
	        },
	
	        /**
	         * Get the version (as Number) of the given property in the User-Agent.
	         * <br>
	         * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
	         *
	         * @param {String} key a key defining a thing which has a version.<br>
	         *        You can use one of following keys:<br>
	         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
	         * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
	         * Opera Mobi, UC Browser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
	         * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon, Gecko, Trident,
	         * Presto, Goanna, iOS, Android, BlackBerry, BREW, Java, Windows Phone OS, Windows
	         * Phone, Windows CE, Windows NT, Symbian, webOS</tt><br>
	         *
	         * @returns {Number} the version as float or <tt>NaN</tt> if User-Agent doesn't contain this version.
	         *          Be careful when comparing this value with '==' operator!
	         * @function MobileDetect#version
	         */
	        version: function (key) {
	            return impl.getVersion(key, this.ua);
	        },
	
	        /**
	         * Get the version (as String) of the given property in the User-Agent.
	         * <br>
	         *
	         * @param {String} key a key defining a thing which has a version.<br>
	         *        You can use one of following keys:<br>
	         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
	         * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
	         * Opera Mobi, UC Browser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
	         * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon, Gecko, Trident,
	         * Presto, Goanna, iOS, Android, BlackBerry, BREW, Java, Windows Phone OS, Windows
	         * Phone, Windows CE, Windows NT, Symbian, webOS</tt><br>
	         *
	         * @returns {String} the "raw" version as String or <tt>null</tt> if User-Agent doesn't contain this version.
	         *
	         * @function MobileDetect#versionStr
	         */
	        versionStr: function (key) {
	            return impl.getVersionStr(key, this.ua);
	        },
	
	        /**
	         * Global test key against userAgent, os, phone, tablet and some other properties of userAgent string.
	         *
	         * @param {String} key the key (case-insensitive) of a userAgent, an operating system, phone or
	         *        tablet family.<br>
	         *        For a complete list of possible values, see {@link MobileDetect#userAgent},
	         *        {@link MobileDetect#os}, {@link MobileDetect#phone}, {@link MobileDetect#tablet}.<br>
	         *        Additionally you have following keys:<br>
	         * <br><tt>Bot, MobileBot, DesktopMode, TV, WebKit, Console, Watch</tt><br>
	         *
	         * @returns {boolean} <tt>true</tt> when the given key is one of the defined keys of userAgent, os, phone,
	         *                    tablet or one of the listed additional keys, otherwise <tt>false</tt>
	         * @function MobileDetect#is
	         */
	        is: function (key) {
	            return containsIC(this.userAgents(), key) ||
	                   equalIC(key, this.os()) ||
	                   equalIC(key, this.phone()) ||
	                   equalIC(key, this.tablet()) ||
	                   containsIC(impl.findMatches(impl.mobileDetectRules.utils, this.ua), key);
	        },
	
	        /**
	         * Do a quick test against navigator::userAgent.
	         *
	         * @param {String|RegExp} pattern the pattern, either as String or RegExp
	         *                        (a string will be converted to a case-insensitive RegExp).
	         * @returns {boolean} <tt>true</tt> when the pattern matches, otherwise <tt>false</tt>
	         * @function MobileDetect#match
	         */
	        match: function (pattern) {
	            if (!(pattern instanceof RegExp)) {
	                pattern = new RegExp(pattern, 'i');
	            }
	            return pattern.test(this.ua);
	        },
	
	        /**
	         * Checks whether the mobile device can be considered as phone regarding <code>screen.width</code>.
	         * <br>
	         * Obviously this method makes sense in browser environments only (not for Node.js)!
	         * @param {number} [maxPhoneWidth] the maximum logical pixels (aka. CSS-pixels) to be considered as phone.<br>
	         *        The argument is optional and if not present or falsy, the value of the constructor is taken.
	         * @returns {boolean|undefined} <code>undefined</code> if screen size wasn't detectable, else <code>true</code>
	         *          when screen.width is less or equal to maxPhoneWidth, otherwise <code>false</code>.<br>
	         *          Will always return <code>undefined</code> server-side.
	         */
	        isPhoneSized: function (maxPhoneWidth) {
	            return MobileDetect.isPhoneSized(maxPhoneWidth || this.maxPhoneWidth);
	        },
	
	        /**
	         * Returns the mobile grade ('A', 'B', 'C').
	         *
	         * @returns {String} one of the mobile grades ('A', 'B', 'C').
	         * @function MobileDetect#mobileGrade
	         */
	        mobileGrade: function () {
	            if (this._cache.grade === undefined) {
	                this._cache.grade = impl.mobileGrade(this);
	            }
	            return this._cache.grade;
	        }
	    };
	
	    // environment-dependent
	    if (typeof window !== 'undefined' && window.screen) {
	        MobileDetect.isPhoneSized = function (maxPhoneWidth) {
	            return maxPhoneWidth < 0 ? undefined : impl.getDeviceSmallerSide() <= maxPhoneWidth;
	        };
	    } else {
	        MobileDetect.isPhoneSized = function () {};
	    }
	
	    // should not be replaced by a completely new object - just overwrite existing methods
	    MobileDetect._impl = impl;
	    
	    MobileDetect.version = '1.3.7 2017-09-06';
	
	    return MobileDetect;
	}); // end of call of define()
	})((function (undefined) {
	    if (typeof module !== 'undefined' && module.exports) {
	        return function (factory) { module.exports = factory(); };
	    } else if (true) {
	        return __webpack_require__(240);
	    } else if (typeof window !== 'undefined') {
	        return function (factory) { window.MobileDetect = factory(); };
	    } else {
	        // please file a bug if you get this error!
	        throw new Error('unknown environment');
	    }
	})());

/***/ }),
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app.js